<script>
  import centralMensagensServico from '../servico';
  import tipoUsuario from '~js/tipo-usuario';
  import iconeModulo from '../icones';
  import desktopEmbed from '~js/desktop-embed';
  import sessaoDesktop from '../sessao-desktop';
  import { rotaPermitida } from '~js/acesso-rota';
  import { criarContextoAcesso } from '~js/acessos';
  import DatePicker from 'vue2-datepicker';
  import moment from 'moment';
  import salvarArquivo from '~js/salvar-arquivo';

  const ATALHOS_PERIODO = [
    { valor: '30', texto: 'Últimos 30 dias' },
    { valor: '90', texto: 'Últimos 90 dias' },
    { valor: 'ano', texto: 'Este ano' },
    { valor: 'tudo', texto: 'Tudo' },
  ];

  const INTERVALO_LISTA = 15000;
  const INTERVALO_CONVERSA = 5000;

  function camposFiltros(coordenador) {
    return {
      periodo: '90',
      dataIni: null,
      dataFim: null,
      modulo: '',
      projeto: '',
      responsavel: '',
      estado: coordenador ? 'todas' : 'abertas',
      leitura: 'todas',
      aguardando: false,
      busca: '',
    };
  }

  const CHAVE_DESTINOS_RECENTES = 'cm-destinos-recentes';
  const CORES_AVATAR = ['#1f4f82', '#0a6d4d', '#8a3ffc', '#a13c3c', '#9a5b00', '#007d79', '#6b4e16', '#b0326b'];

  function semAcento(texto) {
    return ('' + (texto || '')).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }

  function lerDestinosRecentes() {
    try {
      const lista = JSON.parse(localStorage.getItem(CHAVE_DESTINOS_RECENTES) || '[]');
      return Array.isArray(lista) ? lista : [];
    } catch (e) {
      return [];
    }
  }

  const PREFIXO_ANEXO = '[Anexo] ';

  const BASE_ARQUIVOS = {
    compra: 'solicitacaocompras',
    bolsa: 'solicitacaobolsas',
    cursoeventoservico: 'solicitacaoCursoEventoServico',
    pagamento: 'solicitacaopagamentos',
    adiantamento: 'solicitacaoadiantamentos',
    reembolso: 'solicitacaoreembolsos',
    faturamento: 'solicitacaofaturamentos',
    importacao: 'solicitacaoimportacao',
    'reembolso-terceiro': 'solicitacaoreembolsoterceiro',
    transferencia: 'solicitacaotransferencia',
    cancelamentocontrato: 'solicitacaocancelamentocontrato',
    'contratacao-pessoal': 'solicitacaoContratacaoPessoal',
  };

  function nomeBase(caminho) {
    const texto = String(caminho || '');
    return texto.slice(Math.max(texto.lastIndexOf('\\'), texto.lastIndexOf('/')) + 1);
  }

  const MODULOS_ABRIR_DESKTOP = [1, 2, 4, 5, 6, 7, 8, 9, 10, 15, 18];
  const VISAO_MODULO_COMPRA = 12;
  const VISAO_PAGAMENTO_IMPORTACAO = 21;

  export default {
    components: { DatePicker },
    props: {
      embutido: { type: Boolean, default: false },
      moduloUnico: { type: Number, default: 0 },
      numeroUnico: { type: Number, default: 0 },
      fecharModal: { type: Boolean, default: false },
    },
    data() {
      const usuario = this.$storage.usuario() || {};
      const ehCoordenador = usuario.tipoUsuario === tipoUsuario.Coordenador;

      return {
        perfil: ehCoordenador ? 'coordenador' : 'fundacao',
        usuario,
        configuracao: this.$storage.configuracao() || {},
        alturaPagina: 0,
        filtros: camposFiltros(ehCoordenador),
        idProjetoParametro: 0,
        numeroParametro: 0,
        moduloParametro: 0,
        modulos: [],
        registros: [],
        resumo: { naoLidas: 0, aguardando: 0, abertas: 0, encerradas: 0 },
        totalRegistros: 0,
        pagina: 1,
        carregando: true,
        carregandoMais: false,
        requisicao: 0,
        atualizadoEm: null,
        selecionada: null,
        detalhe: null,
        carregandoConversa: false,
        erroConversa: '',
        visao: 'todas',
        texto: '',
        interna: false,
        destino: 0,
        usuariosDestino: [],
        destinoAberto: false,
        copiado: false,
        temporizadorCopiado: null,
        buscaDestino: '',
        indiceDestino: 0,
        destinosRecentes: lerDestinosRecentes(),
        idUsuarioAtual: usuario.id || 0,
        enviando: false,
        mostrarEncerrar: false,
        motivo: '',
        encerrando: false,
        reabrindo: false,
        exportando: false,
        painelDocumentos: false,
        documentosLista: [],
        carregandoDocumentos: false,
        anexando: false,
        arrastando: false,
        temDesktop: desktopEmbed.disponivel(),
        temporizadorBusca: null,
        temporizadorLista: null,
        temporizadorConversa: null,
        lendo: false,
        pendentes: [],
        novasAbaixo: 0,
        buscandoConversa: false,
        moduloAberto: false,
        periodoAberto: false,
        respAberto: false,
        possuiProjetosResponsavel: false,
        responsavelAplicado: 'todos',
        modulosUsuario: [],
        escopoModulo: 'todos',
        atalhosPeriodo: ATALHOS_PERIODO,
      };
    },
    computed: {
      alvoUnico() {
        if (this.moduloUnico > 0 && this.numeroUnico > 0)
          return { modulo: this.moduloUnico, numero: this.numeroUnico };

        const q = this.$route.query || {};
        if (this.$route.name === 'central-mensagens.conversa' && +q.modulo > 0 && +q.numero > 0)
          return { modulo: +q.modulo, numero: +q.numero };

        return null;
      },
      modoUnico() {
        return !!this.alvoUnico;
      },
      coordenador() {
        return this.perfil === 'coordenador';
      },
      fundacao() {
        return !this.coordenador;
      },
      filtroAtivo() {
        const padrao = camposFiltros(this.coordenador);
        return Object.keys(padrao).some(k => this.filtros[k] !== padrao[k]);
      },
      temMais() {
        return this.registros.length < this.totalRegistros;
      },
      conversa() {
        return this.detalhe ? this.detalhe.conversa : null;
      },
      encerrada() {
        return !!(this.conversa && this.conversa.encerrada);
      },
      soInterna() {
        return !!(this.conversa && this.conversa.soInterna && !this.conversa.encerrada);
      },
      internaTravada() {
        return this.fundacao && (this.destino > 0 || (!!this.conversa && (this.conversa.encerrada || this.conversa.soInterna)));
      },
      internaEfetiva() {
        return this.fundacao && (this.internaTravada || this.interna || this.destino > 0);
      },
      itensDestino() {
        const termo = semAcento(this.buscaDestino.trim());
        const usuarios = termo
          ? this.usuariosDestino.filter(u => semAcento(u.nome).indexOf(termo) >= 0)
          : this.usuariosDestino;
        const itens = [];

        if (!termo)
          itens.push({ chave: 'equipe', idUsuario: 0, nome: 'Toda a equipe', dica: 'todos veem' });

        const recentes = termo ? [] : this.destinosRecentes
          .map(id => usuarios.find(u => u.idUsuario === id))
          .filter(Boolean);

        if (recentes.length) {
          itens.push({ chave: 'g-recentes', grupo: 'Recentes' });
          recentes.forEach(u => itens.push({ chave: 'r' + u.idUsuario, idUsuario: u.idUsuario, nome: u.nome }));
          itens.push({ chave: 'g-todos', grupo: 'Todos' });
        }

        usuarios.forEach(u => itens.push({ chave: 'u' + u.idUsuario, idUsuario: u.idUsuario, nome: u.nome }));
        return itens;
      },
      opcoesDestinoEscolhiveis() {
        return this.itensDestino.filter(i => !i.grupo);
      },
      placeholderTexto() {
        if (this.coordenador) return 'Escreva para a fundação…';
        if (this.destino) return 'Mensagem interna para ' + this.nomeDestino + ' (recebe o aviso no painel)';
        if (this.internaEfetiva) return 'Anotação interna — só a equipe da fundação vê';
        return 'Escreva para o coordenador / solicitante…';
      },
      nomeDestino() {
        const u = this.usuariosDestino.find(x => x.idUsuario === this.destino);
        return u ? u.nome : '';
      },
      semCompositor() {
        return this.coordenador && this.encerrada;
      },
      temMensagens() {
        return !!this.detalhe && (this.detalhe.mensagens.length + this.pendentes.length) > 0;
      },
      dicaConversaVazia() {
        if (this.semCompositor) return 'Esta conversa não tem mensagens registradas.';
        if (this.coordenador) return 'Escreva abaixo para falar com a fundação sobre esta solicitação.';
        return 'Escreva abaixo para iniciar a conversa sobre esta solicitação.';
      },
      mensagensVisiveis() {
        if (!this.detalhe) return [];
        return this.detalhe.mensagens.concat(this.pendentes).filter(m => {
          if (this.visao === 'internas') return m.internaExterna === 0;
          if (this.visao === 'externas') return m.internaExterna !== 0;
          return true;
        });
      },
      itensConversa() {
        const itens = [];
        let dia = '';
        let anterior = null;

        this.mensagensVisiveis.forEach(m => {
          const d = moment(m.dataHora);
          const chave = d.format('YYYY-MM-DD');

          if (chave !== dia) {
            dia = chave;
            anterior = null;
            itens.push({ tipo: 'dia', chave: 'dia-' + chave, rotulo: this.rotuloDia(d) });
          }

          const continua = !!anterior
            && anterior.usuarioSistema === m.usuarioSistema
            && anterior.internaExterna === m.internaExterna
            && d.diff(moment(anterior.dataHora), 'minutes') < 10;

          itens.push({ tipo: 'msg', chave: 'm-' + (m.idMensagemSistema || m.chaveLocal), m, continua });
          anterior = m;
        });

        return itens;
      },
      podeEncerrar() {
        return this.fundacao && !!this.conversa && !this.conversa.encerrada && !this.conversa.soInterna;
      },
      podeReabrir() {
        return this.fundacao && this.encerrada;
      },
      podeDocumentos() {
        if (!this.conversa) return false;
        if (!this.tipoArquivo(this.conversa.modulo)) return false;
        return this.fundacao || !!this.configuracao.usarArquivosSolicitacaoCompras;
      },
      chaveConversa() {
        return this.conversa ? this.conversa.modulo + '-' + this.conversa.numero : '';
      },
      podeAnexar() {
        return this.podeDocumentos && !this.semCompositor && !!this.baseArquivos(this.conversa.modulo);
      },
      podeAbrirSolicitacao() {
        if (!this.conversa || this.fundacao || this.modoUnico) return false;
        const rota = this.rotaLista(this.conversa);
        return !!rota && rotaPermitida(rota, this.usuario, this.configuracao);
      },
      moduloDesktop() {
        if (!this.conversa) return 0;
        return this.conversa.moduloVisao === VISAO_MODULO_COMPRA ? VISAO_MODULO_COMPRA : this.conversa.modulo;
      },
      podeAbrirNoDesktop() {
        if (!this.conversa || !this.fundacao || !this.temDesktop) return false;
        if (MODULOS_ABRIR_DESKTOP.indexOf(this.conversa.modulo) < 0) return false;
        const permitidos = sessaoDesktop.modulosAbrir;
        if (!permitidos) return true;
        return permitidos.indexOf(this.moduloDesktop) >= 0 || (this.moduloDesktop === VISAO_MODULO_COMPRA && permitidos.indexOf(1) >= 0);
      },
      textoAbrir() {
        if (!this.conversa) return 'Abrir solicitação';
        if (this.conversa.moduloVisao === VISAO_MODULO_COMPRA) return 'Abrir compra';
        if (this.conversa.modulo === 8 || this.conversa.moduloVisao === VISAO_PAGAMENTO_IMPORTACAO) return 'Abrir importação';
        return 'Abrir solicitação';
      },
      podeSair() {
        return this.embutido && this.temDesktop;
      },
      dicaInterna() {
        if (this.destino > 0) return '— mensagem para um usuário é sempre interna';
        if (this.encerrada) return '— encerrada para o coordenador, segue interna';
        if (this.soInterna) return '— mensageria desativada neste módulo';
        return '— o coordenador não vê';
      },
      periodoTexto() {
        const f = this.filtros;
        if (f.periodo !== 'personalizado') {
          const atalho = ATALHOS_PERIODO.find(a => a.valor === f.periodo);
          return atalho ? atalho.texto : 'Últimos 90 dias';
        }
        const ini = f.dataIni ? moment(f.dataIni).format('DD/MM/YY') : '…';
        const fim = f.dataFim ? moment(f.dataFim).format('DD/MM/YY') : 'hoje';
        return ini + ' a ' + fim;
      },
      opcoesResponsavel() {
        const opcoes = [];
        if (this.possuiProjetosResponsavel)
          opcoes.push({ valor: 'meusprojetos', texto: 'Meus projetos', icone: 'fa-folder-open', dica: 'Projetos em que você é responsável' });
        opcoes.push({ valor: 'todos', texto: 'Todos', icone: 'fa-users', dica: 'Todas as conversas de todos os projetos' });
        opcoes.push({ valor: 'liberacao', texto: 'Liberação comigo', icone: 'fa-user', dica: 'Projetos em que você é o responsável pela liberação' });
        return opcoes;
      },
      responsavelAtual() {
        return this.opcoesResponsavel.find(o => o.valor === this.responsavelAplicado) || this.opcoesResponsavel[0];
      },
      moduloSelecionado() {
        return this.modulos.find(m => '' + m.modulo === this.filtros.modulo) || null;
      },
      moduloNumerico() {
        return /^[0-9]+$/.test(this.filtros.modulo) ? +this.filtros.modulo : 0;
      },
      contagemTexto() {
        const n = this.totalRegistros;
        return n + (n === 1 ? ' conversa' : ' conversas');
      },
    },
    watch: {
      chaveConversa() {
        this.painelDocumentos = false;
        this.documentosLista = [];
      },
      'filtros.periodo'() { this.lista(); },
      'filtros.dataIni'() { if (this.filtros.periodo === 'personalizado') this.lista(); },
      'filtros.dataFim'() { if (this.filtros.periodo === 'personalizado') this.lista(); },
      'filtros.modulo'() { this.lista(); },
      'filtros.responsavel'() { this.lista(); },
      'filtros.estado'() { this.lista(); },
      'filtros.leitura'() { this.lista(); },
      'filtros.aguardando'() { this.lista(); },
      visao() {
        this.novasAbaixo = 0;
        this.$nextTick(() => this.rolarFim());
      },
      'filtros.busca'() { this.listaAdiada(); },
      buscaDestino() { this.indiceDestino = 0; },
      texto() { this.$nextTick(() => this.ajustarCampo()); },
      'filtros.projeto'() { this.listaAdiada(); },
    },
    methods: {
      ajustarAltura() {
        const pagina = this.$refs.pagina;
        if (!pagina) return;

        const rodape = document.querySelector('#page-wrapper .footer');
        const topo = pagina.getBoundingClientRect().top + window.pageYOffset;
        const alturaRodape = rodape ? rodape.offsetHeight : 0;
        this.alturaPagina = Math.max(480, window.innerHeight - topo - alturaRodape);
      },
      aplicarParametros() {
        const q = this.$route.query || {};

        if (q.modulo) {
          this.filtros.modulo = '' + q.modulo;
          this.moduloParametro = +q.modulo || 0;
        }
        if (q.projeto) this.idProjetoParametro = +q.projeto || 0;
        if (q.numero) this.numeroParametro = +q.numero || 0;
      },
      montarFiltros() {
        const f = this.filtros;

        const modulo = this.moduloNumerico;
        const exato = this.numeroParametro && modulo > 0 && [11, 12, 20, 21].indexOf(modulo) < 0;
        const livre = !!this.numeroParametro || !!f.busca.trim();

        return {
          periodo: f.periodo,
          dataIni: f.periodo === 'personalizado' && f.dataIni ? moment(f.dataIni).format('YYYY-MM-DD') : '',
          dataFim: f.periodo === 'personalizado' && f.dataFim ? moment(f.dataFim).format('YYYY-MM-DD') : '',
          modulo: exato ? 0 : modulo,
          moduloExato: exato ? modulo : 0,
          escopoModulo: f.modulo === 'todos' ? 'todos' : '',
          projeto: f.projeto,
          responsavel: f.responsavel,
          estado: livre ? 'todas' : f.estado,
          leitura: livre ? 'todas' : f.leitura,
          aguardando: f.aguardando,
          busca: f.busca,
          idProjeto: this.idProjetoParametro,
          numero: this.numeroParametro,
        };
      },
      listaAdiada() {
        clearTimeout(this.temporizadorBusca);
        this.temporizadorBusca = setTimeout(() => this.lista(), 500);
      },
      lista(silencioso = false) {
        if (this.modoUnico) return Promise.resolve();

        const id = ++this.requisicao;

        if (!silencioso) {
          this.carregando = true;
          this.pagina = 1;
          if (!this.numeroParametro) {
            this.selecionada = null;
            this.detalhe = null;
            this.erroConversa = '';
          }
        }

        const quantidade = silencioso ? Math.max(this.registros.length, 30) : 30;
        const paginas = Math.ceil(quantidade / 30);

        const pedidos = [];
        for (let p = 1; p <= paginas; p++)
          pedidos.push(centralMensagensServico.lista(p, this.montarFiltros()));

        return Promise.all(pedidos)
          .then(respostas => {
            if (id !== this.requisicao) return;

            const primeira = respostas[0];
            const novos = [].concat.apply([], respostas.map(r => r.registros || []));

            if (silencioso && this.selecionada && !novos.some(r => this.mesma(r, this.selecionada))) {
              const antiga = this.registros.findIndex(r => this.mesma(r, this.selecionada));
              if (antiga >= 0) {
                const linha = Object.assign({}, this.registros[antiga], this.conversa || {});
                const data = moment(linha.ultimaData);
                const posicao = novos.findIndex(r => moment(r.ultimaData).isBefore(data));
                novos.splice(posicao < 0 ? novos.length : posicao, 0, linha);
              }
            }

            this.perfil = primeira.perfil || this.perfil;
            this.possuiProjetosResponsavel = !!primeira.possuiProjetosResponsavel;
            this.responsavelAplicado = primeira.responsavelAplicado || 'todos';
            this.modulosUsuario = primeira.modulosUsuario || [];
            this.escopoModulo = primeira.escopoModulo || 'todos';
            this.resumo = primeira.resumo;
            this.totalRegistros = primeira.totalRegistros;
            this.registros = novos;
            this.pagina = paginas;
            this.carregando = false;
            this.atualizadoEm = moment();

            if (!silencioso) this.selecionarInicial();
          })
          .catch(resposta => {
            if (id !== this.requisicao) return;
            this.carregando = false;
            if (!silencioso)
              toastr.error(this.mensagemErro(resposta, 'Não foi possível carregar as conversas.'));
          });
      },
      carregarMais() {
        if (this.carregandoMais || !this.temMais) return;

        this.carregandoMais = true;
        const proxima = this.pagina + 1;

        centralMensagensServico.lista(proxima, this.montarFiltros())
          .then(dados => {
            this.registros = this.registros.concat(dados.registros || []);
            this.pagina = proxima;
            this.carregandoMais = false;
          })
          .catch(() => {
            this.carregandoMais = false;
            toastr.error('Não foi possível carregar mais conversas.');
          });
      },
      selecionarInicial() {
        if (this.registros.length && this.numeroParametro) {
          if (this.selecionada && this.registros.some(r => this.mesma(r, this.selecionada))) return;
          this.selecionar(this.registros[0]);
          return;
        }

        this.selecionada = null;
        this.detalhe = null;
        this.erroConversa = '';
      },
      mesma(a, b) {
        return !!a && !!b && a.modulo === b.modulo && a.numero === b.numero;
      },
      selecionar(r, marcarLida = true) {
        if (this.mesma(r, this.selecionada) && this.detalhe) {
          if (marcarLida) {
            this.lendo = true;
            if (r.naoLidas > 0) this.carregarConversa(false, true);
          }
          return;
        }

        this.selecionada = { modulo: r.modulo, numero: r.numero };
        this.$nextTick(() => this.mostrarSelecionada());
        this.lendo = marcarLida;
        this.texto = '';
        this.interna = false;
        this.visao = 'todas';
        this.pendentes = [];
        this.novasAbaixo = 0;
        this.detalhe = null;
        this.carregarConversa(true, marcarLida);
      },
      carregarConversa(rolar, marcarLida = false, silencioso = false) {
        if (!this.selecionada) return Promise.resolve();

        const alvo = this.selecionada;
        if (!silencioso) {
          this.carregandoConversa = true;
          this.erroConversa = '';
        }

        this.buscandoConversa = true;
        const antes = this.detalhe ? this.detalhe.mensagens.length : 0;
        const estavaNoFim = this.noFim();

        return centralMensagensServico.conversa(alvo.modulo, alvo.numero, marcarLida)
          .then(dados => {
            this.buscandoConversa = false;
            if (!this.mesma(alvo, this.selecionada)) return;

            const novas = silencioso ? Math.max(0, dados.mensagens.length - antes) : 0;
            this.detalhe = dados;
            this.carregandoConversa = false;
            if (marcarLida && dados.leituraRegistrada) this.zerarNaoLidas(alvo);

            if (rolar || (novas > 0 && estavaNoFim)) {
              this.novasAbaixo = 0;
              this.$nextTick(() => this.rolarFim());
            } else if (novas > 0) {
              this.novasAbaixo += novas;
            }
          })
          .catch(resposta => {
            this.buscandoConversa = false;
            if (!this.mesma(alvo, this.selecionada) || silencioso) return;
            this.carregandoConversa = false;
            this.detalhe = null;
            this.erroConversa = this.mensagemErro(resposta, 'Não foi possível abrir a conversa.');
          });
      },
      icone(modulo) {
        return iconeModulo(modulo);
      },
      escolherModulo(valor) {
        const padrao = this.modulosUsuario.length ? 'meus' : 'todos';
        this.filtros.modulo = valor === padrao ? '' : '' + valor;
        this.moduloAberto = false;
      },
      escolherResponsavel(valor) {
        this.respAberto = false;
        const padrao = this.possuiProjetosResponsavel ? 'meusprojetos' : 'todos';
        this.filtros.responsavel = valor === padrao ? '' : valor;
      },
      escolher(campo, valor, aberto) {
        this.filtros[campo] = valor;
        this[aberto] = false;
      },
      escolherPeriodo(valor) {
        this.filtros.dataIni = null;
        this.filtros.dataFim = null;
        this.filtros.periodo = valor;
        this.periodoAberto = false;
      },
      mudarData() {
        if (this.filtros.dataIni || this.filtros.dataFim) {
          this.filtros.periodo = 'personalizado';
          if (this.filtros.dataIni && this.filtros.dataFim && this.filtros.dataFim < this.filtros.dataIni)
            this.filtros.dataFim = this.filtros.dataIni;
        } else {
          this.filtros.periodo = '90';
        }
      },
      iniciais(nome) {
        const partes = ('' + (nome || '')).trim().split(/\s+/).filter(Boolean);
        if (!partes.length) return '?';
        return (partes[0][0] + (partes.length > 1 ? partes[partes.length - 1][0] : '')).toUpperCase();
      },
      corAvatar(id) {
        return CORES_AVATAR[Math.abs(+id || 0) % CORES_AVATAR.length];
      },
      alternarDestino() {
        if (this.destinoAberto) {
          this.destinoAberto = false;
          return;
        }

        this.buscaDestino = '';
        this.indiceDestino = Math.max(0, this.opcoesDestinoEscolhiveis.findIndex(o => o.idUsuario === this.destino));
        this.destinoAberto = true;
        this.$nextTick(() => {
          if (this.$refs.buscaDestino) this.$refs.buscaDestino.focus();
          this.mostrarDestinoAtivo();
        });
      },
      escolherDestino(idUsuario) {
        this.destino = idUsuario;
        this.destinoAberto = false;
        this.$nextTick(() => { const campo = document.getElementById('cm-texto'); if (campo) campo.focus(); });
      },
      teclaDestino(e) {
        const total = this.opcoesDestinoEscolhiveis.length;

        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          if (!total) return;
          this.indiceDestino = (this.indiceDestino + (e.key === 'ArrowDown' ? 1 : total - 1)) % total;
          this.$nextTick(() => this.mostrarDestinoAtivo());
        } else if (e.key === 'Enter') {
          e.preventDefault();
          const opcao = this.opcoesDestinoEscolhiveis[this.indiceDestino];
          if (opcao) this.escolherDestino(opcao.idUsuario);
        } else if (e.key === 'Escape') {
          e.preventDefault();
          this.destinoAberto = false;
        }
      },
      mostrarDestinoAtivo() {
        const lista = this.$refs.listaDestino;
        const item = lista && lista.querySelector('.cm-destino-opcao.ativo');
        if (item && item.scrollIntoView) item.scrollIntoView({ block: 'nearest' });
      },
      lembrarDestino(idUsuario) {
        if (!idUsuario) return;
        this.destinosRecentes = [idUsuario].concat(this.destinosRecentes.filter(id => id !== idUsuario)).slice(0, 5);
        try { localStorage.setItem(CHAVE_DESTINOS_RECENTES, JSON.stringify(this.destinosRecentes)); } catch (e) { }
      },
      fecharSeletores(e) {
        const dentro = (ref) => {
          const el = this.$refs[ref];
          return el && el.contains(e.target);
        };
        if (this.destinoAberto && !dentro('seletorDestino')) this.destinoAberto = false;
        const noCalendario = e.target.closest && e.target.closest('.mx-datepicker-popup, .mx-datepicker-main');

        if (this.moduloAberto && !dentro('seletorModulo')) this.moduloAberto = false;
        if (this.respAberto && !dentro('seletorResp')) this.respAberto = false;
        if (this.periodoAberto && !dentro('seletorPeriodo') && !noCalendario) this.periodoAberto = false;
      },
      mostrarSelecionada() {
        const lista = this.$refs.listaItens;
        const item = lista && lista.querySelector('.cm-item.ativo');
        if (!item) return;

        const topo = item.offsetTop - lista.offsetTop;
        if (topo < lista.scrollTop || topo + item.offsetHeight > lista.scrollTop + lista.clientHeight)
          lista.scrollTop = Math.max(0, topo - 60);
      },
      noFim() {
        const el = this.$refs.mensagens;
        if (!el) return true;
        return el.scrollHeight - el.scrollTop - el.clientHeight < 80;
      },
      aoRolarMensagens() {
        if (this.novasAbaixo && this.noFim()) this.novasAbaixo = 0;
      },
      irParaNovas() {
        this.novasAbaixo = 0;
        this.rolarFim();
      },
      rotuloDia(d) {
        const hoje = moment().startOf('day');
        if (d.isSameOrAfter(hoje)) return 'Hoje';
        if (d.isSameOrAfter(hoje.clone().subtract(1, 'day'))) return 'Ontem';
        if (d.isSameOrAfter(hoje.clone().subtract(6, 'day')))
          return ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'][d.day()];
        return d.format('DD/MM/YYYY');
      },
      horaCurta(data) {
        return moment(data).format('HH:mm');
      },
      tique(m) {
        if (m.pendente) return 'pendente';
        if (m.internaExterna === 0 || !this.nossa(m)) return '';
        return m.leitura ? 'lida' : 'enviada';
      },
      numero(valor) {
        return (+valor || 0).toLocaleString('pt-BR');
      },
      fechadaParaMim(r) {
        return !!r && r.encerrada && this.coordenador;
      },
      zerarNaoLidas(alvo) {
        const linha = this.registros.find(r => this.mesma(r, alvo));

        if (linha && linha.naoLidas > 0 && !this.fechadaParaMim(linha)) {
          this.resumo.naoLidas = Math.max(0, this.resumo.naoLidas - linha.naoLidas);
          linha.naoLidas = 0;
        }
      },
      ajustarCampo() {
        const campo = this.$refs.campoTexto;
        if (!campo) return;
        campo.style.height = 'auto';
        campo.style.height = Math.min(campo.scrollHeight + 2, 132) + 'px';
      },
      rolarFim() {
        const el = this.$refs.mensagens;
        if (el) el.scrollTop = el.scrollHeight;
      },
      enviar() {
        const texto = (this.texto || '').trim();
        if (!texto || this.enviando || !this.selecionada) return;

        this.enviando = true;
        this.lendo = true;
        const alvo = this.selecionada;
        const interna = this.internaEfetiva;
        const destino = this.fundacao ? this.destino : 0;
        const usuario = this.$storage.usuario() || {};
        const pendente = {
          chaveLocal: 'p' + Date.now(),
          pendente: true,
          dataHora: new Date(),
          usuarioSistema: usuario.nome || 'Você',
          campoMensagem: texto,
          internaExterna: this.coordenador ? 1 : (interna ? 0 : 2),
          leitura: null,
          idUsuarioDestino: destino || null,
          nomeDestino: destino ? this.nomeDestino : '',
        };

        this.pendentes.push(pendente);
        this.lembrarDestino(destino);
        this.texto = '';
        this.destino = 0;
        this.novasAbaixo = 0;
        this.$nextTick(() => this.rolarFim());

        centralMensagensServico.enviar(alvo.modulo, alvo.numero, texto, interna, destino)
          .then(() => {
            this.enviando = false;
            return this.carregarConversa(false, false, true);
          })
          .then(() => {
            this.pendentes = this.pendentes.filter(p => p !== pendente);
            this.$nextTick(() => this.rolarFim());
            this.lista(true);
          })
          .catch(resposta => {
            this.enviando = false;
            this.pendentes = this.pendentes.filter(p => p !== pendente);
            if (!this.texto) this.texto = texto;
            if (!this.destino) this.destino = destino;
            toastr.error(this.mensagemErro(resposta, 'Não foi possível enviar a mensagem.'));
          });
      },
      teclaTexto(e) {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault();
          this.enviar();
        }
      },
      abrirEncerrar() {
        this.motivo = '';
        this.mostrarEncerrar = true;
        this.$nextTick(() => { const campo = document.getElementById('cm-motivo'); if (campo) campo.focus(); });
      },
      fecharEncerrar() {
        if (this.encerrando) return;
        this.mostrarEncerrar = false;
      },
      confirmarEncerrar() {
        if (this.encerrando || !this.selecionada) return;

        this.encerrando = true;
        const alvo = this.selecionada;

        centralMensagensServico.encerrar(alvo.modulo, alvo.numero, this.motivo)
          .then(() => {
            this.encerrando = false;
            this.mostrarEncerrar = false;
            toastr.success('Conversa encerrada.');
            this.carregarConversa(true);
            this.lista(true);
          })
          .catch(resposta => {
            this.encerrando = false;
            toastr.error(this.mensagemErro(resposta, 'Não foi possível encerrar a conversa.'));
          });
      },
      reabrir() {
        if (this.reabrindo || !this.selecionada) return;

        this.reabrindo = true;
        const alvo = this.selecionada;

        centralMensagensServico.reabrir(alvo.modulo, alvo.numero)
          .then(() => {
            this.reabrindo = false;
            toastr.success('Conversa reaberta. O coordenador já pode responder.');
            this.carregarConversa(false);
            this.lista(true);
          })
          .catch(resposta => {
            this.reabrindo = false;
            toastr.error(this.mensagemErro(resposta, 'Não foi possível reabrir a conversa.'));
          });
      },
      limparFiltros() {
        this.filtros = camposFiltros(this.coordenador);
      },
      limparParametros() {
        this.idProjetoParametro = 0;
        this.numeroParametro = 0;
        this.moduloParametro = 0;
        this.filtros = camposFiltros(this.coordenador);
        this.lista();
      },
      escolherKpi(tipo) {
        if (this.coordenador && this.kpiAtivo(tipo)) {
          const padrao = camposFiltros(true);
          this.filtros.estado = padrao.estado;
          this.filtros.aguardando = padrao.aguardando;
          this.filtros.leitura = padrao.leitura;
          return;
        }
        this.filtros.estado = tipo === 'tudo' ? 'todas' : 'abertas';
        this.filtros.aguardando = tipo === 'aguardando';
        this.filtros.leitura = tipo === 'naolidas' ? 'naolidas' : 'todas';
      },
      kpiAtivo(tipo) {
        const f = this.filtros;
        if (tipo === 'tudo') return !f.aguardando && f.leitura === 'todas' && f.estado === 'todas';
        if (tipo === 'naolidas') return f.leitura === 'naolidas' && !f.aguardando && f.estado === 'abertas';
        if (tipo === 'aguardando') return f.aguardando && f.leitura === 'todas' && f.estado === 'abertas';
        return !f.aguardando && f.leitura === 'todas' && f.estado === 'abertas';
      },
      enviarDesktop(acao) {
        if (!this.conversa) return;
        desktopEmbed.enviar({ acao, modulo: this.conversa.modulo, id: this.conversa.numero });
      },
      abrirNoDesktop(acao) {
        if (!this.conversa) return;
        desktopEmbed.enviar({ acao, modulo: this.conversa.modulo, moduloVisao: this.conversa.moduloVisao, id: this.conversa.numero });
      },
      abrirSolicitacao() {
        if (!this.conversa) return;

        const rota = this.rotaLista(this.conversa);
        if (rota)
          this.$router.push({ name: rota, query: this.queryLista(this.conversa) });
      },
      queryLista(c) {
        if (c.modulo === 3) return { projeto: '' + (c.idProjeto || '') };
        if (c.modulo === 16) return { beneficiario: ('' + (c.descricao || '')).split(' - ')[0].trim() };
        return { numero: '' + c.numero };
      },
      rotaLista(c) {
        const ctx = criarContextoAcesso(this.usuario, this.configuracao);
        const rateio = !!this.configuracao.utilizarRateioSolicitacoes;

        switch (c.modulo) {
          case 1: return 'solicitacao-compra';
          case 2: return 'solicitacao-bolsa';
          case 3: return 'solicitacao-curso-evento-servico';
          case 4:
            if (c.estrangeiro) return ctx.rotaSolicitacaoEstrangeiroPF;
            return rateio ? ctx.rotaSolicitacaoPFRateio : ctx.rotaSolicitacaoPF;
          case 5: return 'solicitacao-adiantamento';
          case 6: return c.estrangeiro ? 'solicitacao-reembolso-estrangeiro' : 'solicitacao-reembolso-pf';
          case 7:
            if (c.tipoSolicitacao === 2) return 'solicitacao-faturamento-estrangeiro-pf';
            if (c.tipoSolicitacao === 3) return 'solicitacao-faturamento-estrangeiro-pj';
            return 'solicitacao-faturamento-pfpj';
          case 8: return 'solicitacao-importacao-projeto';
          case 9:
            if (c.estrangeiro) return ctx.rotaSolicitacaoEstrangeiroPJ;
            return rateio ? ctx.rotaSolicitacaoPJRateio : ctx.rotaSolicitacaoPJ;
          case 10: return 'solicitacao-reembolso-terceiro';
          case 15: return 'solicitacao-transferencia';
          case 16: return 'solicitacao-cancelamento-contrato';
          case 18: return 'solicitacao-contratacao-pessoal';
          default: return '';
        }
      },
      baseArquivos(modulo) {
        return BASE_ARQUIVOS[this.tipoArquivo(modulo)] || '';
      },
      partesMensagem(texto) {
        const anexos = [];
        const linhas = [];
        String(texto || '').split(/\r?\n/).forEach(linha => {
          if (linha.indexOf(PREFIXO_ANEXO) === 0 && linha.length > PREFIXO_ANEXO.length)
            anexos.push(linha.slice(PREFIXO_ANEXO.length).trim());
          else
            linhas.push(linha);
        });
        return { anexos, texto: linhas.join('\n').trim() };
      },
      iconeAnexo(nome) {
        const ext = (nome.split('.').pop() || '').toLowerCase();
        if (ext === 'pdf') return 'fa-file-pdf-o';
        if (['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'].indexOf(ext) >= 0) return 'fa-file-image-o';
        if (['xls', 'xlsx', 'csv', 'ods'].indexOf(ext) >= 0) return 'fa-file-excel-o';
        if (['doc', 'docx', 'odt', 'rtf'].indexOf(ext) >= 0) return 'fa-file-word-o';
        if (['zip', 'rar', '7z'].indexOf(ext) >= 0) return 'fa-file-archive-o';
        return 'fa-file-o';
      },
      baixarAnexo(nome) {
        if (!this.conversa) return;
        const base = this.baseArquivos(this.conversa.modulo);
        if (!base) return;

        this.$http.get(`/api/${base}/${this.conversa.numero}/downloadarquivo/${encodeURIComponent(nome)}`, { responseType: 'blob' })
          .then(resposta => salvarArquivo(resposta, nome))
          .catch(() => toastr.error('Arquivo não encontrado na pasta da solicitação. Ele pode ter sido removido ou renomeado.'));
      },
      escolherAnexo() {
        if (this.anexando) return;
        this.$refs.arquivoAnexo.value = '';
        this.$refs.arquivoAnexo.click();
      },
      aoEscolherAnexo(e) {
        this.anexar(Array.from(e.target.files || []));
      },
      aoSoltarAnexo(e) {
        this.arrastando = false;
        if (!this.podeAnexar) return;
        this.anexar(Array.from((e.dataTransfer && e.dataTransfer.files) || []));
      },
      anexar(arquivos) {
        arquivos = arquivos.filter(a => a && a.size > 0);
        if (!arquivos.length || this.anexando || !this.selecionada) return;

        const url = `/api/${this.baseArquivos(this.conversa.modulo)}/${this.conversa.numero}/arquivos`;
        const nomesPasta = () => this.$http.get(url).then(res => (res.data || []).map(nomeBase));
        let antes = [];

        this.anexando = true;

        nomesPasta()
          .catch(() => [])
          .then(nomes => {
            antes = nomes;
            const formulario = new FormData();
            arquivos.forEach(a => formulario.append('arquivos', a, a.name));
            return this.$http.post(url, formulario);
          })
          .then(() => nomesPasta().catch(() => []))
          .then(depois => {
            const novos = depois.filter(n => antes.indexOf(n) < 0);
            const nomes = arquivos.map(a => {
              const igual = depois.find(n => semAcento(n).toLowerCase() === semAcento(a.name).toLowerCase());
              const extensao = a.name.split('.').pop().toLowerCase();
              return igual || novos.find(n => n.split('.').pop().toLowerCase() === extensao) || a.name;
            });
            this.documentosLista = depois;
            const legenda = (this.texto || '').trim();
            this.texto = nomes.map(n => PREFIXO_ANEXO + n).join('\n') + (legenda ? '\n' + legenda : '');
            this.anexando = false;
            this.enviar();
          })
          .catch(resposta => {
            this.anexando = false;
            toastr.error(this.mensagemErro(resposta, 'Não foi possível anexar o arquivo na solicitação.'));
          });
      },
      documentos() {
        if (!this.conversa) return;

        this.painelDocumentos = !this.painelDocumentos;
        if (this.painelDocumentos)
          this.carregarDocumentos();
        else
          this.$nextTick(() => this.rolarFim());
      },
      voltarConversa() {
        this.painelDocumentos = false;
        this.$nextTick(() => this.rolarFim());
      },
      carregarDocumentos() {
        const base = this.baseArquivos(this.conversa.modulo);
        if (!base) return;

        const chave = this.chaveConversa;
        this.carregandoDocumentos = true;

        this.$http.get(`/api/${base}/${this.conversa.numero}/arquivos`)
          .then(res => {
            if (chave !== this.chaveConversa) return;
            this.documentosLista = (res.data || []).map(nomeBase);
            this.carregandoDocumentos = false;
          })
          .catch(resposta => {
            this.carregandoDocumentos = false;
            toastr.error(this.mensagemErro(resposta, 'Não foi possível listar os documentos da solicitação.'));
          });
      },
      sair() {
        desktopEmbed.fechar();
      },
      rotaRelatorio(c) {
        switch (c.modulo) {
          case 1: return 'solicitacao-compra.relatorio';
          case 2: return 'solicitacao-bolsa.relatorio';
          case 3: return 'solicitacao-curso-evento-servico.relatorio';
          case 4: return c.estrangeiro ? 'solicitacao-pagamento-estrangeiro-pf.relatorio' : 'solicitacao-pagamento-pf.relatorio';
          case 5: return 'solicitacao-adiantamento.relatorio';
          case 6: return c.estrangeiro ? 'solicitacao-reembolso-estrangeiro.relatorio' : 'solicitacao-reembolso-pf.relatorio';
          case 7:
            if (c.tipoSolicitacao === 2) return 'solicitacao-faturamento-estrangeiro-pf.relatorio';
            if (c.tipoSolicitacao === 3) return 'solicitacao-faturamento-estrangeiro-pj.relatorio';
            return 'solicitacao-faturamento-pfpj.relatorio';
          case 9: return c.estrangeiro ? 'solicitacao-pagamento-estrangeiro-pj.relatorio' : 'solicitacao-pagamento-pj.relatorio';
          case 10: return 'solicitacao-reembolso-terceiro.relatorio';
          case 15: return 'solicitacao-transferencia.relatorio';
          case 16: return 'solicitacao-cancelamento-contrato.relatorio';
          case 18: return 'solicitacao-contratacao-pessoal.relatorio';
          default: return '';
        }
      },
      tipoArquivo(modulo) {
        switch (modulo) {
          case 1: return 'compra';
          case 2: return 'bolsa';
          case 3: return 'cursoeventoservico';
          case 4: return 'pagamento';
          case 5: return 'adiantamento';
          case 6: return 'reembolso';
          case 7: return 'faturamento';
          case 8: return 'importacao';
          case 9: return 'pagamento';
          case 10: return 'reembolso-terceiro';
          case 15: return 'transferencia';
          case 16: return 'cancelamentocontrato';
          case 18: return 'contratacao-pessoal';
          default: return '';
        }
      },
      exportar() {
        if (this.exportando) return;

        this.exportando = true;
        centralMensagensServico.exportar(this.montarFiltros())
          .then(registros => {
            this.exportando = false;
            this.gerarCsv(registros || []);
          })
          .catch(() => {
            this.exportando = false;
            toastr.error('Não foi possível gerar o Excel.');
          });
      },
      gerarCsv(registros) {
        const txt = v => '"' + ('' + (v === null || v === undefined ? '' : v)).replace(/"/g, '""').replace(/\r?\n/g, ' ') + '"';
        const cab = ['Módulo', 'Número', 'Solicitante / descrição', 'Projeto', 'Responsável pela liberação', 'Última mensagem',
          'Último usuário', 'Trecho', 'Não lidas', 'Conversa', 'Aguardando resposta'];
        const linhas = [cab.map(txt).join(';')];

        registros.forEach(r => {
          linhas.push([
            txt(r.descricaoModulo), txt(r.numero), txt(r.descricao), txt(r.projeto), txt(r.responsavel),
            txt(moment(r.ultimaData).format('DD/MM/YYYY HH:mm')), txt(r.ultimoUsuario), txt(r.ultimoTrecho),
            txt(r.naoLidas), txt(r.encerrada ? 'Encerrada' : 'Aberta'), txt(r.aguardando ? 'Sim' : 'Não'),
          ].join(';'));
        });

        const blob = new Blob(['﻿' + linhas.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'central-mensagens-' + moment().format('DD-MM-YYYY') + '.csv';
        link.click();
        URL.revokeObjectURL(url);
      },
      mensagemErro(resposta, padrao) {
        return resposta && resposta.data && resposta.data.message ? resposta.data.message : padrao;
      },
      quando(data) {
        const d = moment(data);
        const hoje = moment().startOf('day');

        if (d.isSameOrAfter(hoje)) return d.format('HH:mm');
        if (d.isSameOrAfter(hoje.clone().subtract(1, 'day'))) return 'ontem';
        if (d.year() === hoje.year()) return d.format('DD/MM');
        return d.format('DD/MM/YY');
      },
      dataHoraCompleta(data) {
        return moment(data).format('DD/MM/YYYY [às] HH:mm');
      },
      horaMensagem(data) {
        const d = moment(data);
        const hoje = moment().startOf('day');

        if (d.isSameOrAfter(hoje)) return 'hoje ' + d.format('HH:mm');
        if (d.isSameOrAfter(hoje.clone().subtract(1, 'day'))) return 'ontem ' + d.format('HH:mm');
        return d.format('DD/MM/YYYY HH:mm');
      },
      nossa(m) {
        return this.coordenador ? m.internaExterna === 1 : m.internaExterna !== 1;
      },
      rotulo(m) {
        if (this.coordenador) return m.internaExterna === 1 ? 'você / sua equipe' : 'fundação';
        if (m.internaExterna === 0) return 'mensagem interna';
        return m.internaExterna === 2 ? 'fundação' : 'coordenação / solicitante';
      },
      lidaPeloOutro(m) {
        if (!m.leitura) return '';
        if (this.fundacao && m.internaExterna === 2) return 'lida pelo coordenador';
        if (this.coordenador && m.internaExterna === 1) return 'lida pela fundação';
        return '';
      },
      moduloCurto(nome) {
        return ('' + (nome || '')).replace(/^Solicitação de /i, '');
      },
      copiarNumero() {
        if (!this.conversa) return;
        const numero = '' + this.conversa.numero;
        const marcar = () => {
          this.copiado = true;
          clearTimeout(this.temporizadorCopiado);
          this.temporizadorCopiado = setTimeout(() => { this.copiado = false; }, 1500);
        };

        if (navigator.clipboard && navigator.clipboard.writeText)
          navigator.clipboard.writeText(numero).then(marcar).catch(() => {});
        else {
          const campo = document.createElement('textarea');
          campo.value = numero;
          document.body.appendChild(campo);
          campo.select();
          try { document.execCommand('copy'); marcar(); } catch (e) { }
          document.body.removeChild(campo);
        }
      },
      paraMim(m) {
        return !!m.idUsuarioDestino && m.idUsuarioDestino === this.idUsuarioAtual;
      },
      podeAvisarDeVolta(m) {
        return this.fundacao && !this.semCompositor && !!m.idUsuarioDestino && !!m.idUsuarioOrigem
          && m.idUsuarioOrigem !== this.idUsuarioAtual && this.destino !== m.idUsuarioOrigem
          && this.usuariosDestino.some(u => u.idUsuario === m.idUsuarioOrigem);
      },
      primeiroNome(nome) {
        return ('' + (nome || '')).trim().split(/\s+/)[0];
      },
      classeBalao(m) {
        if (this.paraMim(m) && !m.leituraDestino) return 'cm-balao cm-balao-interna cm-balao-paramim';
        if (m.internaExterna === 0) return 'cm-balao cm-balao-interna';
        return this.nossa(m) ? 'cm-balao cm-balao-nossa' : 'cm-balao';
      },
      previa(r) {
        return (r.ultimaInternaExterna === 0 && this.fundacao ? 'Interna: ' : '') + (r.ultimoTrecho || '').split(PREFIXO_ANEXO).join('\u{1F4CE} ');
      },
      acompanharAoVivo() {
        this.temporizadorLista = setInterval(() => {
          if (document.hidden || this.carregando || this.enviando || this.carregandoMais) return;
          this.lista(true);
        }, INTERVALO_LISTA);

        this.temporizadorConversa = setInterval(() => {
          if (document.hidden || !this.selecionada || !this.detalhe || this.enviando || this.buscandoConversa) return;
          this.carregarConversa(false, this.lendo && document.hasFocus(), true);
        }, INTERVALO_CONVERSA);
      },
    },
    created() {
      this.aplicarParametros();
    },
    mounted() {
      if (this.fundacao)
        centralMensagensServico.usuarios()
          .then(usuarios => { this.usuariosDestino = (usuarios || []).filter(u => u.idUsuario !== this.idUsuarioAtual); })
          .catch(() => { this.usuariosDestino = []; });

      document.addEventListener('mousedown', this.fecharSeletores);

      if (this.modoUnico) {
        this.carregando = false;
        this.selecionar(this.alvoUnico);
        this.acompanharAoVivo();
        return;
      }

      if (!this.embutido) {
        this.$root.tituloDaPagina = 'Mensagens';
        this.$root.botaoAcaoMostrar = false;
        this.$root.botaoRetrocederMostrar = false;
        this.$root.botaoRetrocederRota = '';
      }

      centralMensagensServico.modulos()
        .then(modulos => { this.modulos = modulos || []; })
        .catch(() => { this.modulos = []; });

      this.lista();
      this.acompanharAoVivo();

      if (!this.embutido) {
        document.body.classList.add('cm-sem-rodape');
        window.addEventListener('resize', this.ajustarAltura);
        this.$nextTick(this.ajustarAltura);
      }
    },
    beforeDestroy() {
      document.body.classList.remove('cm-sem-rodape');
      document.removeEventListener('mousedown', this.fecharSeletores);
      window.removeEventListener('resize', this.ajustarAltura);
      clearTimeout(this.temporizadorBusca);
      clearInterval(this.temporizadorLista);
      clearInterval(this.temporizadorConversa);
    },
  }
</script>

<template>
  <div ref="pagina" :class="['cm-page', embutido ? 'cm-page-embutida' : (modoUnico ? 'cm-page-unica' : 'cm-page-cheia'), { 'cm-page-unica-embed': embutido && modoUnico }]" :style="alturaPagina ? { height: alturaPagina + 'px' } : null">


    <header v-if="!modoUnico" class="cm-topo">
      <div class="cm-titulo">
        <div class="cm-titulo-icone"><i class="fa fa-comments-o"></i></div>
        <div>
          <h1>Central de Mensagens</h1>
          <p v-if="fundacao">Conversas das solicitações com os coordenadores · uso interno da fundação</p>
          <p v-else>Suas conversas com a fundação · só projetos e módulos em que você tem acesso</p>
        </div>
      </div>
      <div class="cm-kpis">
        <button type="button" :class="['cm-kpi', 'cm-kpi-naolidas', { ativo: kpiAtivo('naolidas'), zerado: !resumo.naoLidas }]" @click="escolherKpi('naolidas')"
                title="Só as conversas com mensagem ainda não lida">
          <span class="cm-kpi-icone"><i class="fa fa-envelope"></i></span>
          <span class="cm-kpi-num">{{ numero(resumo.naoLidas) }}</span>
          <span class="cm-kpi-txt">{{ resumo.naoLidas === 1 ? 'mensagem' : 'mensagens' }}<br>não {{ resumo.naoLidas === 1 ? 'lida' : 'lidas' }}</span>
        </button>
        <button type="button" :class="['cm-kpi', 'cm-kpi-aguardando', { ativo: kpiAtivo('aguardando'), zerado: !resumo.aguardando }]" @click="escolherKpi('aguardando')"
                :title="fundacao ? 'A última mensagem foi do coordenador e ainda não respondemos' : 'A última mensagem foi da fundação e espera a sua resposta'">
          <span class="cm-kpi-icone"><i class="fa fa-hourglass-half"></i></span>
          <span class="cm-kpi-num">{{ numero(resumo.aguardando) }}</span>
          <span class="cm-kpi-txt">aguardando<br>{{ fundacao ? 'resposta nossa' : 'sua resposta' }}</span>
        </button>
        <button type="button" :class="['cm-kpi', 'cm-kpi-abertas', { ativo: kpiAtivo('todas') }]" @click="escolherKpi('todas')"
                title="Conversas em andamento no período">
          <span class="cm-kpi-icone"><i class="fa fa-comments"></i></span>
          <span class="cm-kpi-num">{{ numero(resumo.abertas) }}</span>
          <span class="cm-kpi-txt">{{ resumo.abertas === 1 ? 'conversa' : 'conversas' }}<br>{{ resumo.abertas === 1 ? 'aberta' : 'abertas' }}</span>
        </button>
        <button type="button" :class="['cm-kpi', 'cm-kpi-todas', { ativo: kpiAtivo('tudo') }]" @click="escolherKpi('tudo')"
                title="Todas as conversas do período: abertas e encerradas, lidas ou não">
          <span class="cm-kpi-icone"><i class="fa fa-archive"></i></span>
          <span class="cm-kpi-num">{{ numero(resumo.abertas + resumo.encerradas) }}</span>
          <span class="cm-kpi-txt">todas as<br>conversas</span>
        </button>
      </div>
    </header>

    <div v-if="!modoUnico && (idProjetoParametro || numeroParametro || (moduloParametro && escopoModulo === 'meus'))" class="cm-parametros">
      <i class="fa fa-desktop"></i>
      <span>Aberto pelo Desktop com filtro:</span>
      <span v-if="numeroParametro" class="cm-chip">Nº {{ numeroParametro }}</span>
      <span v-if="idProjetoParametro" class="cm-chip">Projeto {{ idProjetoParametro }}</span>
      <span v-if="moduloParametro && escopoModulo === 'meus'" class="cm-chip" title="Só as solicitações marcadas em Meus avisos">seguindo Meus avisos</span>
      <button type="button" class="cm-link" @click="limparParametros">Ver todas as mensagens</button>
    </div>

    <section v-if="!modoUnico" class="cm-filtros" aria-label="Filtros">
      <label class="cm-campo cm-campo-busca">Buscar
        <span class="cm-busca">
          <i class="fa fa-search"></i>
          <input type="text" class="form-control" v-model="filtros.busca"
                 placeholder="Número, solicitante, CPF/CNPJ ou texto da mensagem">
          <button v-if="filtros.busca" type="button" class="cm-limpar-campo" title="Limpar busca"
                  @click.prevent="filtros.busca = ''"><i class="fa fa-trash-o"></i></button>
        </span>
      </label>
      <div class="cm-campo cm-campo-modulo">Módulo
        <div ref="seletorModulo" class="cm-select">
          <button type="button" class="form-control cm-select-botao" :aria-expanded="moduloAberto ? 'true' : 'false'"
                  aria-haspopup="listbox" @click="moduloAberto = !moduloAberto">
            <i v-if="moduloSelecionado" :class="icone(moduloSelecionado.modulo).icone" :style="{ color: icone(moduloSelecionado.modulo).cor }"></i>
            <i v-else-if="escopoModulo === 'meus'" class="fa fa-star cm-laranja"></i>
            <i v-else class="fa fa-th-large cm-cinza"></i>
            <span class="cm-select-texto">{{ moduloSelecionado ? moduloSelecionado.descricao : (escopoModulo === 'meus' ? 'Meus módulos' : 'Todos os módulos') }}</span>
            <i class="fa fa-angle-down cm-select-seta"></i>
          </button>
          <ul v-if="moduloAberto" class="cm-select-lista" role="listbox">
            <li v-if="modulosUsuario.length">
              <button type="button" :class="{ ativo: !moduloSelecionado && escopoModulo === 'meus' }" @click="escolherModulo('meus')"
                      title="Os módulos marcados na sua configuração de avisos">
                <i class="fa fa-star cm-laranja"></i> Meus módulos
              </button>
            </li>
            <li>
              <button type="button" :class="{ ativo: !moduloSelecionado && escopoModulo !== 'meus' }" @click="escolherModulo('todos')">
                <i class="fa fa-th-large cm-cinza"></i> Todos os módulos
              </button>
            </li>
            <li v-for="m in modulos" :key="m.modulo">
              <button type="button" :class="{ ativo: filtros.modulo === '' + m.modulo }" @click="escolherModulo(m.modulo)">
                <i :class="icone(m.modulo).icone" :style="{ color: icone(m.modulo).cor }"></i> {{ m.descricao }}
                <i v-if="modulosUsuario.indexOf(m.modulo) >= 0" class="fa fa-star cm-laranja cm-estrela" title="Está nos seus módulos"></i>
                <span v-if="m.soInterna" class="cm-tag cm-tag-interna">só interna</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
      <label class="cm-campo cm-campo-projeto">{{ fundacao ? 'Projeto' : 'Meus projetos' }}
        <span class="cm-busca cm-busca-sem-icone">
          <input type="text" class="form-control" v-model="filtros.projeto"
                 :placeholder="fundacao ? 'Código ou nome do projeto' : 'Todos os meus projetos'">
          <button v-if="filtros.projeto" type="button" class="cm-limpar-campo" title="Limpar projeto"
                  @click.prevent="filtros.projeto = ''"><i class="fa fa-trash-o"></i></button>
        </span>
      </label>
      <div v-if="fundacao" class="cm-campo cm-campo-resp" title="Responsável pela liberação do projeto">Responsável
        <div ref="seletorResp" class="cm-select">
          <button type="button" class="form-control cm-select-botao" :aria-expanded="respAberto ? 'true' : 'false'"
                  aria-haspopup="listbox" @click="respAberto = !respAberto">
            <i :class="['fa', responsavelAtual.icone, 'cm-azul']"></i>
            <span class="cm-select-texto">{{ responsavelAtual.texto }}</span>
            <i class="fa fa-angle-down cm-select-seta"></i>
          </button>
          <ul v-if="respAberto" class="cm-select-lista" role="listbox">
            <li v-for="o in opcoesResponsavel" :key="o.valor">
              <button type="button" :class="{ ativo: responsavelAplicado === o.valor }" @click="escolherResponsavel(o.valor)" :title="o.dica">
                <i :class="['fa', o.icone, 'cm-azul']"></i> {{ o.texto }}
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div class="cm-campo cm-campo-periodo">Período
        <div ref="seletorPeriodo" class="cm-select">
          <button type="button" class="form-control cm-select-botao" :aria-expanded="periodoAberto ? 'true' : 'false'"
                  @click="periodoAberto = !periodoAberto">
            <i class="fa fa-calendar cm-cinza"></i>
            <span class="cm-select-texto">{{ periodoTexto }}</span>
            <i class="fa fa-angle-down cm-select-seta"></i>
          </button>
          <div v-if="periodoAberto" class="cm-select-lista cm-periodo-painel">
            <div class="cm-periodo-atalhos">
              <button v-for="a in atalhosPeriodo" :key="a.valor" type="button"
                      :class="{ ativo: filtros.periodo === a.valor }" @click="escolherPeriodo(a.valor)">{{ a.texto }}</button>
            </div>
            <div class="cm-periodo-datas">
              <span class="cm-periodo-rotulo">Ou escolha as datas</span>
              <div class="cm-periodo-linha">
                <date-picker v-model="filtros.dataIni" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                             placeholder="De" :editable="false" :shortcuts="false" :clearable="true" @change="mudarData"></date-picker>
                <span>até</span>
                <date-picker v-model="filtros.dataFim" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                             placeholder="Hoje" :editable="false" :shortcuts="false" :clearable="true" @change="mudarData"></date-picker>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button type="button" :class="['btn', filtroAtivo ? 'btn-warning' : 'btn-white', 'cm-btn']" @click="limparFiltros">
        <i class="fa fa-eraser"></i> Limpar filtros
      </button>
    </section>

    <main class="cm-corpo">
      <section v-if="!modoUnico" class="cm-lista" aria-label="Conversas">
        <div class="cm-lista-topo">
          <span>{{ contagemTexto }}</span>
          <span>Mais recentes primeiro</span>
        </div>
        <div ref="listaItens" class="cm-lista-itens">
          <div v-if="carregando" class="cm-vazio"><i class="fa fa-spinner fa-pulse"></i> Carregando conversas...</div>
          <template v-else>
            <button v-for="r in registros" :key="r.modulo + '-' + r.numero" type="button"
                    :class="['cm-item', { ativo: selecionada && selecionada.modulo === r.modulo && selecionada.numero === r.numero, encerrada: fechadaParaMim(r) }]"
                    @click="selecionar(r)">
              <span :class="['cm-ponto', { 'cm-ponto-nao-lida': r.naoLidas > 0 && !fechadaParaMim(r), 'cm-ponto-aguardando': !(r.naoLidas > 0) && r.aguardando }]"></span>
              <span class="cm-item-corpo">
                <span class="cm-item-linha">
                  <span :class="['cm-item-titulo', { forte: r.naoLidas > 0 && !fechadaParaMim(r) }]">{{ r.descricao || ('Nº ' + r.numero) }}</span>
                  <span class="cm-item-quando">{{ quando(r.ultimaData) }}</span>
                </span>
                <span class="cm-item-linha cm-item-sub" :title="r.descricaoModulo + ' nº ' + r.numero + (r.tipoCompra ? ' · ' + r.tipoCompra : '') + (r.projeto ? ' · ' + r.projeto : '')">
                  <span class="cm-item-modulo"><i :class="icone(r.moduloVisao || r.modulo).icone" :style="{ color: icone(r.moduloVisao || r.modulo).cor }"></i> {{ moduloCurto(r.descricaoModulo) }}</span>
                  <span class="cm-item-numero">Nº {{ r.numero }}</span>
                  <span v-if="r.tipoCompra" class="cm-tag cm-tag-tipo">{{ r.tipoCompra }}</span>
                  <span v-if="r.projeto" class="cm-item-projeto">{{ r.projeto }}</span>
                </span>
                <span class="cm-item-linha">
                  <span class="cm-item-previa">{{ previa(r) }}</span>
                  <span class="cm-item-marcas">
                    <span v-if="r.encerrada" class="cm-tag" :title="fundacao ? 'Encerrada para o coordenador; segue aberta para mensagens internas' : ''"><i class="fa fa-lock"></i> {{ fundacao ? 'Encerrada p/ coordenador' : 'Encerrada' }}</span>
                    <span v-if="r.soInterna && fundacao" class="cm-tag cm-tag-interna">Só interna</span>
                    <span v-if="r.naoLidas > 0 && !fechadaParaMim(r)" class="cm-contador">{{ r.naoLidas }}</span>
                  </span>
                </span>
              </span>
            </button>
            <div v-if="!registros.length" class="cm-vazio-bonito">
              <span class="cm-vazio-icone"><i :class="['fa', filtroAtivo || filtros.busca ? 'fa-search' : 'fa-comments-o']"></i></span>
              <strong>{{ filtroAtivo ? 'Nenhuma conversa com esses filtros' : 'Nenhuma conversa no período' }}</strong>
              <span>{{ filtroAtivo ? 'Tente outro período, módulo ou termo de busca.' : 'Quando chegar uma mensagem, ela aparece aqui.' }}</span>
              <button v-if="filtroAtivo" type="button" class="btn btn-warning cm-btn" @click="limparFiltros">
                <i class="fa fa-eraser"></i> Limpar filtros
              </button>
            </div>
            <button v-if="temMais" type="button" class="cm-mais" :disabled="carregandoMais" @click="carregarMais">
              <i :class="['fa', carregandoMais ? 'fa-spinner fa-pulse' : 'fa-angle-down']"></i>
              Carregar mais ({{ registros.length }} de {{ totalRegistros }})
            </button>
          </template>
        </div>
      </section>

      <section class="cm-conversa" aria-label="Conversa selecionada">
        <div v-if="carregando && !conversa" class="cm-conversa-vazia">
          <div class="cm-vazio"><i class="fa fa-spinner fa-pulse"></i> Carregando conversas...</div>
        </div>
        <div v-else-if="!conversa && !carregandoConversa" class="cm-conversa-vazia">
          <div class="cm-vazio-bonito">
            <span class="cm-vazio-icone cm-vazio-icone-grande"><i class="fa fa-comments-o"></i></span>
            <strong>{{ erroConversa ? 'Não foi possível abrir a conversa' : 'Nenhuma conversa aberta' }}</strong>
            <span>{{ erroConversa || 'Escolha uma conversa na lista ao lado para ler e responder.' }}</span>
          </div>
        </div>

        <template v-if="conversa">
          <div class="cm-conversa-topo">
            <div class="cm-conversa-info">
              <div class="cm-conversa-tags">
                <span class="cm-modulo-icone" :style="{ color: icone(conversa.moduloVisao || conversa.modulo).cor, background: icone(conversa.moduloVisao || conversa.modulo).cor + '1a' }">
                  <i :class="icone(conversa.moduloVisao || conversa.modulo).icone"></i>
                </span>
                <span class="cm-modulo-nome">{{ conversa.descricaoModulo }}</span>
                <button type="button" class="cm-numero" :title="copiado ? 'Número copiado' : 'Clique para copiar o número'" @click="copiarNumero">
                  Nº {{ conversa.numero }} <i :class="['fa', copiado ? 'fa-check' : 'fa-clone']"></i>
                </button>
                <span v-if="conversa.tipoCompra" class="cm-tipo-destaque"><i class="fa fa-tag"></i> {{ conversa.tipoCompra }}</span>
                <span v-if="modoUnico" class="cm-ao-vivo cm-ao-vivo-topo" title="Ao vivo: a conversa se atualiza sozinha"></span>
              </div>
              <h2>{{ conversa.descricao || ('Solicitação nº ' + conversa.numero) }}</h2>
              <p>
                <span v-if="conversa.projeto">{{ conversa.projeto }} · </span>Responsável pela liberação:
                <strong>{{ conversa.responsavel || 'não informado' }}</strong>
              </p>
            </div>
            <div v-if="fundacao" class="cm-segmento cm-segmento-baixo" role="group" aria-label="Mostrar mensagens">
              <button type="button" :class="{ ativo: visao === 'todas' }" @click="visao = 'todas'">Todas</button>
              <button type="button" :class="{ ativo: visao === 'externas' }" @click="visao = 'externas'">Com o coordenador</button>
              <button type="button" :class="{ ativo: visao === 'internas' }" @click="visao = 'internas'">Internas</button>
            </div>
          </div>

          <div v-if="encerrada && fundacao" class="cm-faixa cm-faixa-encerrada">
            <span class="cm-faixa-icone"><i class="fa fa-lock"></i></span>
            <span>
              <strong>Encerrada para o coordenador</strong>
              <template v-if="detalhe.encerramento"> por {{ detalhe.encerramento.nomeUsuarioEncerramento }} em {{ dataHoraCompleta(detalhe.encerramento.dataEncerramento) }}</template>.
              Ele vê o histórico, mas não responde mais. Aqui a conversa segue aberta e as mensagens novas são internas.
            </span>
          </div>
          <div v-if="soInterna && fundacao" class="cm-faixa cm-faixa-interna">
            <i class="fa fa-exclamation-triangle"></i>
            <span><strong>Mensageria desativada para {{ conversa.descricaoModulo }}.</strong> O coordenador não vê esta conversa na Web, por isso só dá para registrar mensagens internas.</span>
          </div>

          <div v-if="painelDocumentos" class="cm-docs" aria-label="Documentos da solicitação">
            <div class="cm-docs-topo">
              <i class="fa fa-paperclip"></i>
              <strong>Documentos da solicitação</strong>
              <span v-if="!carregandoDocumentos" class="cm-docs-qtd">{{ documentosLista.length }}</span>
              <small>Arquivos da pasta da solicitação nº {{ conversa.numero }}. O que for anexado pela conversa também aparece aqui.</small>
            </div>
            <div class="cm-docs-lista">
              <div v-if="carregandoDocumentos" class="cm-vazio"><i class="fa fa-spinner fa-pulse"></i> Carregando documentos…</div>
              <div v-else-if="!documentosLista.length" class="cm-vazio">
                Nenhum documento nesta solicitação ainda.<template v-if="podeAnexar"> Use o <i class="fa fa-paperclip"></i> para anexar.</template>
              </div>
              <template v-else>
                <button v-for="nome in documentosLista" :key="nome" type="button" class="cm-anexo cm-docs-item"
                        :title="'Baixar ' + nome" @click="baixarAnexo(nome)">
                  <i :class="['fa', iconeAnexo(nome), 'cm-anexo-icone']"></i>
                  <span class="cm-anexo-nome">{{ nome }}</span>
                  <i class="fa fa-download cm-anexo-baixar"></i>
                </button>
              </template>
            </div>
            <div class="cm-docs-rodape">
              <button v-if="podeAnexar" type="button" class="btn btn-primary cm-btn" :disabled="anexando" @click="escolherAnexo">
                <i :class="['fa', anexando ? 'fa-spinner fa-pulse' : 'fa-paperclip']"></i> Anexar arquivo
              </button>
              <button type="button" class="btn btn-white cm-btn" @click="voltarConversa">
                <i class="fa fa-comments-o"></i> Voltar à conversa
              </button>
            </div>
          </div>
          <div v-show="!painelDocumentos" ref="mensagens" class="cm-mensagens" @scroll="aoRolarMensagens">
            <div v-if="!mensagensVisiveis.length" class="cm-vazio-bonito cm-vazio-conversa">
              <template v-if="temMensagens">
                <span class="cm-vazio-icone"><i class="fa fa-filter"></i></span>
                <strong>Nenhuma mensagem nesta visão</strong>
                <span>{{ visao === 'internas' ? 'Esta conversa ainda não tem mensagens internas.' : 'Esta conversa ainda não tem mensagens com o coordenador.' }}</span>
                <button type="button" class="btn btn-white cm-btn" @click="visao = 'todas'"><i class="fa fa-comments-o"></i> Ver todas</button>
              </template>
              <template v-else>
                <span class="cm-vazio-icone cm-vazio-icone-grande"><i class="fa fa-comment-o"></i></span>
                <strong>Nenhuma mensagem ainda</strong>
                <span>{{ dicaConversaVazia }}</span>
              </template>
            </div>
            <template v-for="item in itensConversa">
              <div v-if="item.tipo === 'dia'" :key="item.chave" class="cm-dia"><span>{{ item.rotulo }}</span></div>
              <div v-else :key="item.chave"
                   :class="['cm-linha', { 'cm-linha-nossa': nossa(item.m), 'cm-linha-continua': item.continua }]">
                <div :class="classeBalao(item.m)">
                  <div v-if="!item.continua" class="cm-balao-topo">
                    <i v-if="item.m.internaExterna === 0" class="fa fa-lock cm-icone-interna"></i>
                    <strong>{{ item.m.usuarioSistema || 'Sistema' }}</strong>
                    <span class="cm-rotulo">{{ rotulo(item.m) }}</span>
                    <span v-if="item.m.idUsuarioDestino" :class="['cm-tag', 'cm-tag-destino', { 'cm-tag-destino-meu': paraMim(item.m) }]"
                          :title="item.m.leituraDestino ? 'Aviso visto em ' + horaMensagem(item.m.leituraDestino) : 'Aviso ainda não visto'">
                      <i class="fa fa-bell-o"></i> avisou {{ paraMim(item.m) ? 'você' : item.m.nomeDestino }}
                      <i v-if="item.m.leituraDestino" class="fa fa-check"></i>
                    </span>
                  </div>
                  <div v-else-if="item.m.idUsuarioDestino" class="cm-balao-topo">
                    <span :class="['cm-tag', 'cm-tag-destino', { 'cm-tag-destino-meu': paraMim(item.m) }]">
                      <i class="fa fa-bell-o"></i> avisou {{ paraMim(item.m) ? 'você' : item.m.nomeDestino }}
                    </span>
                  </div>
                  <template v-if="partesMensagem(item.m.campoMensagem).anexos.length">
                    <button v-for="(nome, i) in partesMensagem(item.m.campoMensagem).anexos" :key="'a' + i" type="button"
                            class="cm-anexo" :title="'Baixar ' + nome + ' (anexado na solicitação)'" @click="baixarAnexo(nome)">
                      <i :class="['fa', iconeAnexo(nome), 'cm-anexo-icone']"></i>
                      <span class="cm-anexo-nome">{{ nome }}</span>
                      <i class="fa fa-download cm-anexo-baixar"></i>
                    </button>
                    <div v-if="partesMensagem(item.m.campoMensagem).texto" class="cm-balao-texto">{{ partesMensagem(item.m.campoMensagem).texto }}</div>
                  </template>
                  <div v-else class="cm-balao-texto">{{ item.m.campoMensagem }}</div>
                  <div class="cm-balao-pe" :title="lidaPeloOutro(item.m)">
                    <button v-if="podeAvisarDeVolta(item.m)" type="button" class="cm-avisar-volta" @click="escolherDestino(item.m.idUsuarioOrigem)"
                            :title="'Escrever uma mensagem interna que avisa ' + item.m.usuarioSistema + ' no painel'">
                      <i class="fa fa-reply"></i> Avisar {{ primeiroNome(item.m.usuarioSistema) }}
                    </button>
                    <span>{{ horaCurta(item.m.dataHora) }}</span>
                    <i v-if="tique(item.m) === 'pendente'" class="fa fa-clock-o cm-tique"></i>
                    <span v-else-if="tique(item.m) === 'enviada'" class="cm-tique"><i class="fa fa-check"></i></span>
                    <span v-else-if="tique(item.m) === 'lida'" class="cm-tique cm-tique-lida"><i class="fa fa-check"></i><i class="fa fa-check"></i></span>
                  </div>
                </div>
              </div>
            </template>
            <div v-if="encerrada && detalhe.encerramento" class="cm-encerramento">
              <i class="fa fa-lock"></i>
              <span>{{ fundacao ? 'Encerrada para o coordenador por ' + detalhe.encerramento.nomeUsuarioEncerramento + ' · daqui em diante só internas' : 'Conversa encerrada pela fundação' }}</span>
              <em>{{ dataHoraCompleta(detalhe.encerramento.dataEncerramento) }}</em>
            </div>
          </div>
          <div class="cm-novas-ancora">
            <button v-if="novasAbaixo" type="button" class="cm-novas" @click="irParaNovas">
              <i class="fa fa-arrow-down"></i> {{ novasAbaixo }} {{ novasAbaixo === 1 ? 'nova mensagem' : 'novas mensagens' }}
            </button>
          </div>

          <div v-if="semCompositor" class="cm-compositor cm-compositor-bloqueado">
            <span class="cm-bloqueado-icone"><i class="fa fa-lock"></i></span>
            <span class="cm-bloqueado-texto">
              <strong>Conversa encerrada pela fundação<template v-if="detalhe && detalhe.encerramento"> em {{ dataHoraCompleta(detalhe.encerramento.dataEncerramento) }}</template></strong>
              <span>Você pode consultar o histórico, mas não é possível responder.</span>
            </span>
          </div>
          <div v-else :class="['cm-compositor', { 'cm-compositor-arrastando': arrastando }]"
               @dragover.prevent="arrastando = podeAnexar" @dragleave.self="arrastando = false" @drop.prevent="aoSoltarAnexo">
            <div class="cm-compositor-linha">
              <template v-if="podeAnexar">
                <input ref="arquivoAnexo" type="file" multiple class="cm-arquivo-oculto" @change="aoEscolherAnexo">
                <button type="button" class="cm-clipe" :disabled="anexando || enviando" @click="escolherAnexo"
                        title="Anexar arquivo: ele vai para a pasta da solicitação e aparece na conversa (também dá para arrastar o arquivo aqui)"
                        aria-label="Anexar arquivo">
                  <i :class="['fa', anexando ? 'fa-spinner fa-pulse' : 'fa-paperclip']"></i>
                </button>
              </template>
              <textarea id="cm-texto" ref="campoTexto" v-model="texto" rows="1" @keydown="teclaTexto" @input="ajustarCampo"
                        :class="['cm-texto', { 'cm-texto-interna': internaEfetiva }]"
                        :title="coordenador ? 'A fundação recebe sua mensagem e responde por aqui. Enter envia · Shift+Enter quebra linha' : 'Enter envia · Shift+Enter quebra linha'"
                        :placeholder="placeholderTexto"></textarea>
              <button type="button" :class="['cm-enviar', { 'cm-enviar-interna': internaEfetiva }]"
                      :disabled="!texto.trim() || enviando" @click="enviar"
                      :title="internaEfetiva ? 'Salvar interna (Enter)' : 'Enviar (Enter)'" :aria-label="internaEfetiva ? 'Salvar interna' : 'Enviar'">
                <i :class="['fa', enviando ? 'fa-spinner fa-pulse' : 'fa-paper-plane']"></i>
              </button>
            </div>
            <div v-if="fundacao" class="cm-compositor-acoes">
              <button v-if="podeEncerrar" type="button" class="btn cm-btn cm-btn-encerrar" @click="abrirEncerrar"
                      title="Encerra a conversa: o coordenador não pode mais responder pela Web">
                <i class="fa fa-lock"></i> Encerrar conversa
              </button>
              <div class="cm-enviar-grupo">
                <div v-if="fundacao && usuariosDestino.length" ref="seletorDestino" class="cm-destino">
                  <button type="button" :class="['cm-destino-botao', { escolhido: destino > 0 }]" aria-haspopup="listbox"
                          :aria-expanded="destinoAberto ? 'true' : 'false'" @click="alternarDestino"
                          title="Dirigir a mensagem interna a uma pessoa: ela recebe o aviso no painel, mesmo sem este módulo marcado">
                    <span v-if="destino" class="cm-avatar" :style="{ background: corAvatar(destino) }">{{ iniciais(nomeDestino) }}</span>
                    <i v-else class="fa fa-users cm-destino-icone"></i>
                    <span class="cm-destino-texto">{{ destino ? nomeDestino : 'Para: toda a equipe' }}</span>
                    <span v-if="destino" class="cm-destino-limpar" role="button" title="Voltar para toda a equipe" @click.stop="destino = 0">
                      <i class="fa fa-times"></i>
                    </span>
                    <i v-else :class="['fa', destinoAberto ? 'fa-angle-down' : 'fa-angle-up', 'cm-destino-seta']"></i>
                  </button>
                  <div v-if="destinoAberto" class="cm-destino-pop">
                    <div class="cm-destino-busca">
                      <i class="fa fa-search"></i>
                      <input ref="buscaDestino" v-model="buscaDestino" type="text" placeholder="Buscar pessoa…" @keydown="teclaDestino">
                    </div>
                    <ul ref="listaDestino" class="cm-destino-lista" role="listbox">
                      <template v-for="item in itensDestino">
                        <li v-if="item.grupo" :key="item.chave" class="cm-destino-grupo">{{ item.grupo }}</li>
                        <li v-else :key="item.chave">
                          <button type="button" role="option" :aria-selected="item.idUsuario === destino ? 'true' : 'false'"
                                  :class="['cm-destino-opcao', { ativo: opcoesDestinoEscolhiveis[indiceDestino] === item, marcado: item.idUsuario === destino }]"
                                  @mouseenter="indiceDestino = opcoesDestinoEscolhiveis.indexOf(item)" @click="escolherDestino(item.idUsuario)">
                            <span v-if="item.idUsuario" class="cm-avatar" :style="{ background: corAvatar(item.idUsuario) }">{{ iniciais(item.nome) }}</span>
                            <span v-else class="cm-avatar cm-avatar-equipe"><i class="fa fa-users"></i></span>
                            <span class="cm-destino-nome">{{ item.nome }}<small v-if="item.dica">{{ item.dica }}</small></span>
                            <i v-if="item.idUsuario === destino" class="fa fa-check cm-destino-check"></i>
                          </button>
                        </li>
                      </template>
                      <li v-if="!opcoesDestinoEscolhiveis.length" class="cm-destino-vazio">Ninguém encontrado com “{{ buscaDestino }}”.</li>
                    </ul>
                  </div>
                </div>
                <label :class="['cm-interna', { travada: internaTravada, marcada: internaEfetiva }]" :title="dicaInterna">
                  <input type="checkbox" :checked="internaEfetiva" :disabled="internaTravada" @change="interna = !interna">
                  <i class="fa fa-lock"></i> Mensagem interna
                </label>
              </div>
            </div>
          </div>
        </template>
      </section>
    </main>

    <footer class="cm-rodape">
      <div v-if="!modoUnico" class="cm-rodape-info" title="A lista e a conversa aberta se atualizam sozinhas">
        <span class="cm-ao-vivo"></span> Ao vivo · {{ contagemTexto }}
      </div>
      <div class="cm-rodape-acoes">
        <button v-if="podeDocumentos" type="button" :class="['btn', 'btn-white', 'cm-btn', { 'cm-btn-ativo': painelDocumentos }]" @click="documentos"
                :title="painelDocumentos ? 'Voltar à conversa' : 'Documentos anexados à solicitação'">
          <i class="fa fa-paperclip"></i> Documentos
        </button>
        <button v-if="podeAbrirSolicitacao" type="button" class="btn btn-white cm-btn" @click="abrirSolicitacao"
                title="Abre a lista do módulo já filtrada por esta solicitação">
          <i class="fa fa-external-link"></i> Abrir solicitação
        </button>
        <button v-if="podeAbrirNoDesktop" type="button" class="btn btn-white cm-btn" @click="abrirNoDesktop('abrirSolicitacao')"
                title="Abre a tela do módulo no Manager já filtrada por esta solicitação">
          <i class="fa fa-external-link"></i> {{ textoAbrir }}
        </button>
        <button v-if="podeReabrir" type="button" class="btn btn-white cm-btn cm-btn-forte" :disabled="reabrindo" @click="reabrir"
                title="Reabre a conversa para o coordenador responder">
          <i :class="['fa', reabrindo ? 'fa-spinner fa-pulse' : 'fa-unlock']"></i> Reabrir conversa
        </button>
        <span v-if="!modoUnico" class="cm-sep"></span>
        <button v-if="!modoUnico" type="button" class="btn btn-primary cm-btn" :disabled="exportando || !totalRegistros" @click="exportar"
                title="Exporta as conversas da lista, com os filtros atuais, para Excel">
          <i :class="['fa', exportando ? 'fa-spinner fa-pulse' : 'fa-file-excel-o']"></i> {{ exportando ? 'Exportando...' : 'Exportar Excel' }}
        </button>
        <button v-if="fecharModal" type="button" class="btn cm-btn cm-btn-sair" @click="$emit('fechar')">
          <i class="fa fa-sign-out"></i> Sair
        </button>
        <button v-if="podeSair" type="button" class="btn cm-btn cm-btn-sair" @click="sair">
          <i class="fa fa-sign-out"></i> Sair
        </button>
      </div>
    </footer>

    <div v-if="mostrarEncerrar" class="cm-modal-fundo">
      <div class="cm-modal" role="dialog" aria-modal="true" aria-labelledby="cm-tit-encerrar">
        <div class="cm-modal-topo">
          <h3 id="cm-tit-encerrar">Encerrar conversa</h3>
          <p>{{ conversa.descricaoModulo }} nº {{ conversa.numero }} · {{ conversa.descricao }}</p>
        </div>
        <div class="cm-modal-corpo">
          <div class="cm-modal-aviso">
            O coordenador continua vendo o histórico, mas a caixa de resposta some para ele na Web.
            Para a equipe da fundação a conversa segue aberta: o que for escrito depois vira mensagem interna. Dá para reabrir para o coordenador depois.
          </div>
          <label class="cm-campo" for="cm-motivo">Última mensagem ao coordenador (opcional)
            <textarea id="cm-motivo" v-model="motivo" rows="4" maxlength="1000" class="form-control"
                      placeholder="Se escrever, ela entra como a última mensagem da conversa"></textarea>
          </label>
        </div>
        <div class="cm-modal-rodape">
          <button type="button" class="btn btn-warning cm-btn cm-btn-forte" :disabled="encerrando" @click="confirmarEncerrar">
            <i :class="['fa', encerrando ? 'fa-spinner fa-pulse' : 'fa-lock']"></i> Encerrar
          </button>
          <button type="button" class="btn cm-btn cm-btn-sair" :disabled="encerrando" @click="fecharEncerrar">
            <i class="fa fa-sign-out"></i> Sair
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  body.cm-sem-rodape #page-wrapper .footer { display: none; }
</style>

<style scoped>
  .cm-page {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 225px);
    min-height: 560px;
    background: #f3f5f7;
    color: #1c2024;
    border: 1px solid #e1e5ea;
    position: relative;
  }
  .cm-page { user-select: none; -webkit-user-select: none; -ms-user-select: none; }
  .cm-page .cm-balao, .cm-page .cm-balao *, .cm-page input, .cm-page textarea, .cm-page .modal-body { user-select: text; -webkit-user-select: text; -ms-user-select: text; }
  .cm-page .cm-balao { cursor: text; }
  .cm-page-cheia {
    margin: 0 -15px;
    border-left: none;
    border-right: none;
  }
  .cm-page-unica {
    height: 70vh;
    min-height: 420px;
  }
  .cm-page-embutida {
    height: 100vh;
    min-height: 0;
    border: none;
  }

  .cm-topo {
    flex: 0 0 auto;
    background: #fff;
    border-bottom: 1px solid #e1e5ea;
    padding: 14px 20px 12px;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
  .cm-titulo { display: flex; align-items: center; gap: 12px; min-width: 0; flex: 1 1 auto; }
  .cm-titulo > div:last-child { min-width: 0; }
  .cm-titulo-icone {
    width: 40px; height: 40px; border-radius: 10px; background: #e3f4ee; color: #0a6d4d;
    display: flex; align-items: center; justify-content: center; font-size: 20px;
  }
  .cm-titulo h1 { margin: 0; font-size: 19px; font-weight: 600; color: #1c2024; }
  .cm-titulo p { margin: 2px 0 0; font-size: 12.5px; color: #5b6570; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .cm-kpis { display: flex; flex-wrap: nowrap; gap: 8px; flex: 0 0 auto; margin-left: auto; }
  .cm-kpi { white-space: nowrap; }
  .cm-kpi {
    --kpi-cor: #5b6570; --kpi-suave: #f1f3f5; --kpi-borda: #c6ccd4;
    display: flex; align-items: center; gap: 9px; min-height: 44px; padding: 6px 14px 6px 8px;
    background: #fff; border: 1px solid #e1e5ea; border-radius: 6px; cursor: pointer; text-align: left;
    transition: border-color .12s, background .12s;
  }
  .cm-kpi:hover { border-color: #c6ccd4; }
  .cm-kpi:focus { outline: none; }
  .cm-kpi:focus-visible { box-shadow: 0 0 0 3px rgba(31, 79, 130, .15); }
  .cm-kpi-icone {
    flex: 0 0 auto; width: 26px; height: 26px; border-radius: 50%; background: var(--kpi-suave); color: var(--kpi-cor);
    display: inline-flex; align-items: center; justify-content: center; font-size: 12px;
  }
  .cm-kpi-num { font-family: 'IBM Plex Mono', Consolas, monospace; font-variant-numeric: tabular-nums; font-size: 21px; font-weight: 500; color: #1c2024; }
  .cm-kpi-txt { font-size: 11.5px; color: #5b6570; line-height: 1.25; }
  .cm-kpi-naolidas { --kpi-cor: #a13c3c; --kpi-suave: #fbeeee; --kpi-borda: #d9a3a3; }
  .cm-kpi-naolidas .cm-kpi-num { color: #a13c3c; }
  .cm-kpi-aguardando { --kpi-cor: #9a6a00; --kpi-suave: #fdf4e2; --kpi-borda: #e2c27e; }
  .cm-kpi-aguardando .cm-kpi-num { color: #9a5b00; }
  .cm-kpi-abertas { --kpi-cor: #0a6d4d; --kpi-suave: #e3f4ee; --kpi-borda: #9fd3bd; }
  .cm-kpi-todas { --kpi-cor: #1f4f82; --kpi-suave: #eaf2fb; --kpi-borda: #a9c3e0; }
  .cm-kpi.zerado .cm-kpi-num { color: #8a939c; }
  .cm-kpi.zerado .cm-kpi-icone { opacity: .55; }
  .cm-kpi.ativo { border-color: var(--kpi-borda); background: var(--kpi-suave); }
  .cm-kpi.ativo .cm-kpi-icone { background: #fff; }
  .cm-vermelho { color: #a13c3c; }
  .cm-laranja { color: #9a5b00; }

  .cm-parametros {
    flex: 0 0 auto; background: #e3f4ee; border-bottom: 1px solid #c3e6d8; padding: 8px 20px;
    display: flex; flex-wrap: wrap; align-items: center; gap: 8px; font-size: 12.5px; color: #0a4f38;
  }
  .cm-chip { background: #fff; border: 1px solid #b5dccb; border-radius: 999px; padding: 2px 10px; font-weight: 600; }
  .cm-link { margin-left: auto; background: transparent; border: none; color: #0a6d4d; font-weight: 600; cursor: pointer; padding: 4px; }

  .cm-filtros {
    flex: 0 0 auto; background: #fff; border-bottom: 1px solid #e1e5ea; padding: 10px 20px;
    display: flex; flex-wrap: wrap; align-items: flex-end; gap: 10px;
  }
  .cm-campo { display: flex; flex-direction: column; gap: 4px; margin: 0; font-size: 12px; color: #5b6570; font-weight: 600; }
  .cm-campo .form-control { height: 34px; font-size: 13px; font-weight: 400; color: #1c2024; }
  .cm-campo { min-width: 0; }
  .cm-campo-busca { flex: 2 1 140px; }
  .cm-campo-modulo { flex: 1 1 150px; }
  .cm-campo-projeto { flex: 1 1 110px; }
  .cm-campo-resp { flex: 0 1 115px; }
  .cm-campo-curto { flex: 0 0 130px; }
  .cm-select { position: relative; }
  .cm-select-botao {
    display: flex; align-items: center; gap: 8px; width: 100%; text-align: left; background: #fff; cursor: pointer;
    font-size: 13px; color: #1c2024; font-weight: 400; padding: 6px 10px;
  }
  .cm-select-texto { flex: 1 1 auto; min-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .cm-select-seta { color: #5b6570; }
  .cm-select-lista {
    position: absolute; z-index: 30; top: 36px; left: 0; min-width: 100%; width: max-content; max-width: 420px;
    max-height: 380px; overflow-y: auto; margin: 0; padding: 4px 0; list-style: none;
    background: #fff; border: 1px solid #c6ccd4; border-radius: 4px; box-shadow: 0 8px 24px rgba(16, 24, 40, 0.18);
  }
  .cm-select-lista button {
    display: flex; align-items: center; gap: 9px; width: 100%; border: none; background: #fff; text-align: left;
    padding: 7px 12px; font-size: 13px; font-weight: 400; color: #1c2024; cursor: pointer; white-space: nowrap;
  }
  .cm-select-lista button:hover { background: #f2f5f7; }
  .cm-select-lista button.ativo { background: #e3f4ee; font-weight: 600; }
  .cm-select-lista i, .cm-select-botao i:first-child { width: 16px; text-align: center; }
  .cm-cinza { color: #8a939c; }
  .cm-select-lista .cm-estrela { font-size: 10px; margin-left: auto; width: auto; }
  .cm-azul { color: #1c84c6; }
  .cm-verde { color: #1ab394; }
  .cm-campo-periodo { flex: 0 0 165px; }
  .cm-periodo-linha >>> .mx-datepicker input[readonly] { background: #fff; cursor: pointer; }
  .cm-periodo-painel { width: 300px; max-width: 300px; padding: 10px; overflow: visible; max-height: none; }
  .cm-periodo-atalhos { display: grid; grid-template-columns: 1fr 1fr; gap: 6px; }
  .cm-periodo-atalhos button {
    border: 1px solid #e1e5ea; border-radius: 3px; background: #fff; padding: 7px 8px; font-size: 12.5px;
    font-weight: 500; color: #3d464f; cursor: pointer; white-space: nowrap;
  }
  .cm-periodo-atalhos button:hover { background: #f2f5f7; }
  .cm-periodo-atalhos button.ativo { background: #1c2024; border-color: #1c2024; color: #fff; }
  .cm-periodo-datas { margin-top: 10px; padding-top: 10px; border-top: 1px solid #eef0f3; }
  .cm-periodo-rotulo { display: block; font-size: 11.5px; color: #5b6570; font-weight: 600; margin-bottom: 6px; }
  .cm-periodo-linha { display: flex; align-items: center; gap: 6px; font-size: 12px; color: #5b6570; font-weight: 400; }
  .cm-periodo-linha >>> .mx-datepicker { width: 122px; }
  .cm-periodo-linha >>> .mx-datepicker input { height: 32px; padding: 0 26px 0 8px; font-size: 12.5px; font-family: 'IBM Plex Mono', Consolas, monospace; }
  .cm-busca { position: relative; display: block; }
  .cm-busca i { position: absolute; left: 10px; top: 10px; color: #8a939c; }
  .cm-busca .form-control { padding-left: 30px; padding-right: 30px; }
  .cm-busca-sem-icone .form-control { padding-left: 12px; }
  .cm-busca .cm-limpar-campo {
    position: absolute; right: 4px; top: 50%; transform: translateY(-50%); width: 26px; height: 26px; padding: 0;
    border: 0; background: transparent; color: #8a939c; cursor: pointer;
  }
  .cm-busca .cm-limpar-campo i { position: static; color: inherit; }
  .cm-busca .cm-limpar-campo:hover { color: #c9302c; }
  .cm-segmento { display: flex; border: 1px solid #c6ccd4; border-radius: 3px; overflow: hidden; height: 34px; background: #fff; }
  .cm-segmento button {
    border: none; border-right: 1px solid #c6ccd4; padding: 0 10px; font-size: 13px; background: #fff; color: #3d464f; cursor: pointer; white-space: nowrap;
  }
  .cm-segmento button:last-child { border-right: none; }
  .cm-segmento button.ativo { background: #1c2024; color: #fff; font-weight: 600; }
  .cm-segmento-baixo { height: 32px; }
  .cm-btn { height: 34px; display: inline-flex; align-items: center; gap: 6px; }

  .cm-corpo { flex: 1 1 auto; display: flex; min-height: 0; }

  .cm-lista {
    flex: 0 0 400px; max-width: 42%; background: #fff; border-right: 1px solid #e1e5ea;
    display: flex; flex-direction: column; min-width: 0; min-height: 0;
  }
  .cm-lista-topo {
    flex: 0 0 auto; padding: 8px 16px; border-bottom: 1px solid #eef0f3;
    display: flex; justify-content: space-between; font-size: 12px; color: #5b6570;
  }
  .cm-lista-itens { flex: 1 1 auto; overflow-y: auto; overflow-x: hidden; min-height: 0; }
  .cm-item {
    width: 100%; text-align: left; border: none; border-bottom: 1px solid #eef0f3; background: #fff;
    display: flex; gap: 10px; align-items: flex-start; padding: 10px 14px 10px 12px; cursor: pointer; color: inherit;
  }
  .cm-item:hover { background: #f7f9fa; }
  .cm-item.ativo, .cm-item.ativo:hover { background: #dcf1e9; box-shadow: inset 4px 0 0 #1ab394; }
  .cm-item.ativo .cm-item-titulo { color: #0a4f38; font-weight: 700; }
  .cm-item.ativo .cm-item-previa { color: #3d464f; }
  .cm-item.encerrada { opacity: 0.78; }
  .cm-ponto { flex: 0 0 8px; width: 8px; height: 8px; border-radius: 50%; margin-top: 6px; background: transparent; }
  .cm-ponto-nao-lida { background: #a13c3c; }
  .cm-ponto-aguardando { background: #c98a00; }
  .cm-item-corpo { display: flex; flex-direction: column; gap: 3px; min-width: 0; flex: 1 1 auto; }
  .cm-item-linha { display: flex; justify-content: space-between; align-items: center; gap: 8px; min-width: 0; }
  .cm-item-titulo { font-size: 13px; font-weight: 500; color: #3d464f; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .cm-item-titulo.forte { font-weight: 700; color: #1c2024; }
  .cm-item-quando { font-size: 11px; color: #5b6570; white-space: nowrap; font-family: 'IBM Plex Mono', Consolas, monospace; }
  .cm-item-sub { justify-content: flex-start; gap: 6px; font-size: 12px; color: #5b6570; }
  .cm-item-modulo { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 46px; flex: 0 1 auto; font-weight: 600; color: #3d464f; }
  .cm-item-numero {
    flex: 0 0 auto; font-family: 'IBM Plex Mono', Consolas, monospace; font-size: 12px; font-weight: 700; color: #1c2024;
    background: #eef0f3; border-radius: 4px; padding: 0 6px; line-height: 18px;
  }
  .cm-item-sub .cm-tag-tipo { flex: 0 1 auto; min-width: 60px; max-width: none; }
  .cm-item-modulo i { width: 14px; text-align: center; }
  .cm-modulo i { margin-right: 3px; }
  .cm-item-projeto { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 0; flex: 1 1 0; color: #8a939c; }
  .cm-item-previa { font-size: 12.5px; color: #5b6570; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .cm-item-marcas { display: inline-flex; gap: 4px; align-items: center; flex: 0 0 auto; }
  .cm-tag { background: #eef0f3; color: #3d464f; border-radius: 4px; padding: 0 6px; font-size: 11px; font-weight: 600; white-space: nowrap; }
  .cm-tag-interna { background: #fff6e5; color: #7a4800; border: 1px solid #f0d49a; }
  .cm-tag-tipo { background: #eaf2fb; color: #1f4f82; max-width: 150px; overflow: hidden; text-overflow: ellipsis; }
  .cm-tag-destino { background: #eaf2fb; color: #1f4f82; }
  .cm-tag-destino-meu { background: #1f4f82; color: #fff; }
  .cm-contador {
    background: #a13c3c; color: #fff; border-radius: 999px; font-size: 11px; font-weight: 600;
    min-width: 20px; height: 20px; padding: 0 6px; display: inline-flex; align-items: center; justify-content: center;
  }
  .cm-vazio { padding: 40px 20px; text-align: center; color: #5b6570; font-size: 13px; }
  .cm-vazio-bonito {
    display: flex; flex-direction: column; align-items: center; gap: 6px; text-align: center;
    padding: 48px 24px; color: #5b6570; font-size: 13px;
  }
  .cm-vazio-bonito strong { font-size: 14.5px; font-weight: 600; color: #1c2024; margin-top: 6px; }
  .cm-vazio-bonito span { max-width: 260px; line-height: 1.45; }
  .cm-vazio-bonito .btn { margin-top: 10px; }
  .cm-vazio-icone {
    width: 56px; height: 56px; border-radius: 50%; background: #e3f4ee; color: #0a6d4d;
    display: inline-flex !important; align-items: center; justify-content: center; font-size: 22px; max-width: none !important;
  }
  .cm-vazio-icone-grande { width: 72px; height: 72px; font-size: 30px; }
  .cm-vazio-conversa { margin: auto 0; }
  .cm-mais { width: 100%; border: none; background: #f7f9fa; color: #0a6d4d; font-weight: 600; padding: 10px; cursor: pointer; }

  .cm-conversa { flex: 1 1 auto; display: flex; flex-direction: column; min-width: 0; min-height: 0; background: #f7f8fa; }
  .cm-conversa-vazia {
    flex: 1 1 auto; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px;
    color: #8a939c; font-size: 13px;
  }
  .cm-conversa-topo {
    flex: 0 0 auto; background: #fff; border-bottom: 1px solid #e1e5ea; padding: 10px 20px;
    display: flex; justify-content: space-between; gap: 10px; align-items: flex-start;
  }
  .cm-conversa-info { min-width: 0; flex: 1 1 auto; }
  .cm-conversa-topo .cm-segmento { flex: 0 0 auto; }
  .cm-conversa-info h2, .cm-conversa-info p { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .cm-conversa-tags { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }
  .cm-modulo-icone { width: 28px; height: 28px; border-radius: 6px; display: inline-flex; align-items: center; justify-content: center; font-size: 14px; flex: 0 0 auto; }
  .cm-modulo-nome { font-size: 13px; font-weight: 600; color: #3d464f; }
  .cm-conversa-tags .cm-numero {
    font-family: 'IBM Plex Mono', Consolas, monospace; font-size: 16px; font-weight: 700; color: #1c2024;
    background: #f3f5f7; border: 1px solid #dfe3e8; border-radius: 6px; padding: 1px 9px; cursor: pointer; line-height: 24px;
  }
  .cm-conversa-tags .cm-numero i { font-size: 11px; color: #8a939c; margin-left: 4px; }
  .cm-conversa-tags .cm-numero:hover { border-color: #b9c3ce; background: #fff; }
  .cm-tipo-destaque {
    display: inline-flex; align-items: center; gap: 5px; font-size: 12.5px; font-weight: 700; color: #1f4f82;
    background: #e3edf8; border: 1px solid #c4d6ec; border-radius: 6px; padding: 2px 9px; line-height: 20px;
  }
  .cm-modulo { background: #eef0f3; color: #3d464f; border-radius: 4px; padding: 2px 8px; font-size: 12px; font-weight: 600; }
  .cm-numero { font-family: 'IBM Plex Mono', Consolas, monospace; font-size: 13px; color: #3d464f; }
  .cm-conversa-info h2 { margin: 6px 0 2px; font-size: 16px; font-weight: 600; color: #1c2024; }
  .cm-conversa-info p { margin: 0; font-size: 12.5px; color: #5b6570; }
  .cm-conversa-info strong { color: #3d464f; font-weight: 600; }

  .cm-faixa { flex: 0 0 auto; padding: 9px 20px; display: flex; gap: 10px; align-items: center; font-size: 12.5px; }
  .cm-faixa-encerrada { background: #f4f6f8; border-bottom: 1px solid #dfe3e8; color: #3d464f; }
  .cm-faixa-icone { width: 26px; height: 26px; border-radius: 50%; background: #e1e6eb; color: #5b6570; display: inline-flex; align-items: center; justify-content: center; flex: 0 0 auto; font-size: 12px; }
  .cm-encerramento { align-self: center; display: inline-flex; align-items: center; gap: 8px; margin: 14px 0 6px; padding: 7px 16px; border-radius: 999px; background: #f4f6f8; border: 1px solid #dfe3e8; color: #3d464f; font-size: 12px; }
  .cm-encerramento i { color: #8a94a0; }
  .cm-encerramento em { font-style: normal; color: #8a94a0; }
  .cm-encerramento em::before { content: '·'; margin-right: 8px; }
  .cm-faixa-interna { background: #fff6e5; border-bottom: 1px solid #f0d49a; color: #5c3a00; }
  .cm-faixa-interna i { color: #9a5b00; }

  .cm-mensagens { flex: 1 1 auto; overflow-y: auto; padding: 14px 20px 18px; display: flex; flex-direction: column; gap: 3px; min-height: 0; }
  .cm-mensagens > * { flex-shrink: 0; }
  .cm-linha { display: flex; justify-content: flex-start; margin-top: 10px; }
  .cm-linha-continua { margin-top: 4px; }
  .cm-linha-nossa { justify-content: flex-end; }
  .cm-dia { display: flex; justify-content: center; margin: 12px 0 2px; }
  .cm-dia span {
    background: #fff; border: 1px solid #e1e5ea; border-radius: 999px; padding: 2px 12px;
    font-size: 11.5px; color: #5b6570; font-weight: 600; box-shadow: 0 1px 1px rgba(16, 24, 40, 0.04);
  }
  .cm-balao-pe { display: flex; justify-content: flex-end; align-items: center; gap: 4px; margin-top: 2px; font-size: 11px; color: #5b6570; font-family: 'IBM Plex Mono', Consolas, monospace; }
  .cm-tique { color: #8a939c; display: inline-flex; }
  .cm-tique-lida { color: #1c84c6; }
  .cm-tique-lida i + i { margin-left: -6px; }
  .cm-novas-ancora { position: relative; height: 0; }
  .cm-novas {
    position: absolute; bottom: 12px; left: 50%; transform: translateX(-50%); z-index: 2;
    background: #1c2024; color: #fff; border: none; border-radius: 999px; padding: 6px 14px;
    font-size: 12px; font-weight: 600; box-shadow: 0 4px 12px rgba(16, 24, 40, 0.25); cursor: pointer;
  }
  .cm-ao-vivo { width: 8px; height: 8px; border-radius: 50%; background: #1ab394; box-shadow: 0 0 0 3px rgba(26, 179, 148, 0.18); display: inline-block; }
  .cm-balao { max-width: 72%; padding: 9px 13px; border-radius: 10px; background: #fff; border: 1px solid #e1e5ea; }
  .cm-balao-nossa { background: #e3f4ee; border-color: #c3e6d8; }
  .cm-balao-interna { background: #fff6e5; border: 1px dashed #d9a441; }
  .cm-balao-paramim { border: 2px solid #1f4f82; }
  .cm-avisar-volta { margin-right: auto; padding: 1px 8px; border: 1px solid #c9d8ea; border-radius: 999px; background: #fff; color: #1f4f82; font-size: 11px; font-family: inherit; cursor: pointer; }
  .cm-avisar-volta:hover, .cm-avisar-volta:focus { background: #eaf2fb; border-color: #9db7d6; }
  .cm-balao-topo { display: flex; gap: 8px; align-items: center; margin-bottom: 3px; font-size: 12px; }
  .cm-balao-topo strong { font-weight: 600; }
  .cm-balao-nossa .cm-balao-topo strong { color: #0a4f38; }
  .cm-balao-interna .cm-balao-topo strong { color: #7a4800; }
  .cm-icone-interna { color: #9a5b00; }
  .cm-rotulo { color: #5b6570; }
  .cm-balao-texto { font-size: 13.5px; line-height: 1.5; white-space: pre-wrap; word-break: break-word; }
  .cm-divisor { display: flex; align-items: center; gap: 10px; color: #5b6570; font-size: 12px; }
  .cm-divisor span { flex: 1 1 auto; height: 1px; background: #dfe3e8; }
  .cm-divisor em { font-style: normal; }

  .cm-compositor { flex: 0 0 auto; background: #fff; border-top: 1px solid #e1e5ea; padding: 10px 20px 12px; display: flex; flex-direction: column; gap: 8px; }
  .cm-compositor-bloqueado { flex-direction: row; align-items: center; gap: 12px; padding: 12px 20px; background: #f7f8fa; border-top: 1px solid #e3e7eb; }
  .cm-bloqueado-icone { width: 34px; height: 34px; border-radius: 50%; background: #e1e6eb; color: #5b6570; display: inline-flex; align-items: center; justify-content: center; flex: 0 0 auto; font-size: 14px; }
  .cm-bloqueado-texto { display: flex; flex-direction: column; gap: 2px; }
  .cm-bloqueado-texto strong { font-size: 13px; color: #1c2024; font-weight: 600; }
  .cm-bloqueado-texto span { font-size: 12px; color: #5b6570; }
  .cm-compositor-rotulo { margin: 0; font-size: 12px; color: #5b6570; font-weight: 600; }
  .cm-compositor-linha { display: flex; align-items: flex-end; gap: 10px; }
  .cm-texto {
    flex: 1 1 auto; width: 100%; border: 1px solid #c6ccd4; border-radius: 20px; padding: 9px 16px; font-size: 13.5px; line-height: 20px;
    color: #1c2024; resize: none; background: #fff; height: 40px; min-height: 40px; max-height: 132px; overflow-y: auto; outline: none;
    transition: border-color .15s, box-shadow .15s;
  }
  .cm-texto:focus { border-color: #1ab394; box-shadow: 0 0 0 3px rgba(26, 179, 148, .15); }
  .cm-texto-interna { border: 1px dashed #d9a441; background: #fffaf0; }
  .cm-texto-interna:focus { border-color: #c98a22; box-shadow: 0 0 0 3px rgba(217, 164, 65, .18); }
  .cm-enviar {
    flex: 0 0 auto; width: 40px; height: 40px; border-radius: 50%; border: none; background: #1ab394; color: #fff;
    display: inline-flex; align-items: center; justify-content: center; font-size: 15px; cursor: pointer; transition: background .15s, opacity .15s;
  }
  .cm-enviar i { margin-left: -2px; }
  .cm-enviar:hover:not([disabled]) { background: #159a80; }
  .cm-enviar-interna { background: #9a5b00; }
  .cm-enviar-interna:hover:not([disabled]) { background: #7a4800; }
  .cm-enviar[disabled] { opacity: .45; cursor: not-allowed; }
  .cm-ao-vivo-topo { margin-left: 2px; }
  .cm-compositor-acoes { display: flex; flex-wrap: wrap; gap: 10px; align-items: center; justify-content: space-between; }
  .cm-interna {
    display: flex; align-items: center; gap: 7px; margin: 0; font-size: 13px; color: #3d464f; font-weight: 400; cursor: pointer;
    height: 34px; padding: 0 12px; border: 1px solid #e7eaec; border-radius: 3px; background: #fff;
  }
  .cm-interna input { margin: 0; width: 15px; height: 15px; }
  .cm-interna i { color: #9a5b00; }
  .cm-interna.marcada { background: #fff6e5; border-color: #f0d49a; color: #5c3a00; font-weight: 600; }
  .cm-interna.travada { cursor: not-allowed; }
  .cm-arquivo-oculto { display: none; }
  .cm-docs { flex: 1 1 auto; display: flex; flex-direction: column; min-height: 0; background: #fff; }
  .cm-docs-topo { flex: 0 0 auto; display: flex; flex-wrap: wrap; align-items: center; gap: 4px 8px; padding: 12px 20px; border-bottom: 1px solid #e6e9ee; color: #1c2024; }
  .cm-docs-topo small { flex: 1 0 100%; color: #5b6570; font-size: 12px; }
  .cm-docs-qtd { min-width: 20px; padding: 0 6px; border-radius: 10px; background: #eef0f3; color: #3a434c; font-size: 12px; font-weight: 600; text-align: center; }
  .cm-docs-lista { flex: 1 1 auto; overflow-y: auto; padding: 12px 20px; display: grid; grid-template-columns: repeat(auto-fill, minmax(260px, 1fr)); gap: 8px; align-content: start; }
  .cm-docs-lista .cm-vazio { grid-column: 1 / -1; }
  .cm-docs-item { max-width: none; margin: 0; }
  .cm-docs-rodape { flex: 0 0 auto; display: flex; justify-content: flex-end; gap: 8px; padding: 10px 20px; border-top: 1px solid #e6e9ee; }
  .cm-btn-ativo { background: #eaf1f9; border-color: #b9cde4; color: #1f4f82; }
  .cm-clipe { flex: 0 0 auto; width: 38px; height: 38px; border: 1px solid #dfe3e8; border-radius: 50%; background: #fff; color: #5b6570; font-size: 17px; }
  .cm-clipe:hover:not(:disabled), .cm-clipe:focus { background: #f2f4f7; color: #1f4f82; border-color: #b9c3cf; }
  .cm-clipe:disabled { opacity: 0.6; cursor: default; }
  .cm-compositor-arrastando { outline: 2px dashed #1f4f82; outline-offset: -4px; background: #f3f7fc; }
  .cm-anexo { display: flex; align-items: center; gap: 10px; width: 100%; max-width: 360px; margin: 2px 0 6px; padding: 8px 10px; border: 1px solid #dfe3e8; border-radius: 8px; background: rgba(255, 255, 255, 0.75); color: #1c2024; text-align: left; }
  .cm-anexo:hover, .cm-anexo:focus { background: #fff; border-color: #b9c3cf; }
  .cm-anexo-icone { font-size: 22px; color: #a13c3c; flex: 0 0 auto; }
  .cm-anexo-nome { flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-weight: 600; }
  .cm-anexo-baixar { color: #5b6570; flex: 0 0 auto; }
  .cm-btn-encerrar { background: #fff; color: #9a5b00; border: 1px solid #f0c27a; }
  .cm-btn-encerrar:hover, .cm-btn-encerrar:focus { background: #fff4e5; color: #7a4800; border-color: #e0a64a; }
  .cm-destino { position: relative; }
  .cm-destino-botao {
    display: flex; align-items: center; gap: 8px; height: 34px; padding: 0 10px; max-width: 250px;
    border: 1px solid #e7eaec; border-radius: 3px; background: #fff; color: #3d464f; font-size: 13px; cursor: pointer;
  }
  .cm-destino-botao:hover { border-color: #c9d3de; }
  .cm-destino-botao.escolhido { border-color: #9db7d6; background: #f2f6fb; color: #1f4f82; font-weight: 600; padding-left: 5px; }
  .cm-destino-icone, .cm-destino-seta { color: #8a939c; }
  .cm-destino-texto { flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; text-align: left; }
  .cm-destino-limpar { color: #5b6570; width: 18px; height: 18px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; }
  .cm-destino-limpar:hover { background: #dde6f0; color: #1c2024; }
  .cm-avatar {
    flex: 0 0 auto; width: 24px; height: 24px; border-radius: 50%; color: #fff; font-size: 10.5px; font-weight: 700;
    display: inline-flex; align-items: center; justify-content: center; letter-spacing: .02em;
  }
  .cm-avatar-equipe { background: #eef0f3; color: #5b6570; font-size: 11px; }
  .cm-destino-pop {
    position: absolute; right: 0; bottom: calc(100% + 6px); width: 300px; z-index: 30;
    background: #fff; border: 1px solid #d9dee4; border-radius: 6px; box-shadow: 0 8px 24px rgba(16, 24, 40, .16);
    display: flex; flex-direction: column; overflow: hidden;
  }
  .cm-destino-busca { display: flex; align-items: center; gap: 8px; padding: 8px 10px; border-bottom: 1px solid #eef0f3; }
  .cm-destino-busca i { color: #8a939c; }
  .cm-destino-busca input { flex: 1 1 auto; border: none; outline: none; font-size: 13px; background: transparent; min-width: 0; }
  .cm-destino-lista { list-style: none; margin: 0; padding: 4px 0; max-height: 280px; overflow-y: auto; }
  .cm-destino-grupo { padding: 8px 12px 4px; font-size: 10.5px; font-weight: 700; letter-spacing: .05em; text-transform: uppercase; color: #8a939c; }
  .cm-destino-opcao {
    width: 100%; display: flex; align-items: center; gap: 10px; padding: 6px 12px; border: none; background: none;
    text-align: left; font-size: 13px; color: #1c2024; cursor: pointer;
  }
  .cm-destino-opcao.ativo { background: #eef3f9; }
  .cm-destino-opcao.marcado { font-weight: 600; }
  .cm-destino-nome { flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .cm-destino-nome small { margin-left: 6px; font-weight: 400; color: #8a939c; font-size: 11.5px; }
  .cm-destino-check { color: #1f4f82; }
  .cm-destino-vazio { padding: 14px 12px; font-size: 12.5px; color: #5b6570; text-align: center; }
  .cm-modal-corpo .cm-interna { height: auto; padding: 0; border: none; background: none; }
  .cm-dica { font-size: 12px; color: #5b6570; }
  .cm-enviar-grupo { display: flex; gap: 8px; align-items: center; margin-left: auto; }
  .cm-caracteres { font-size: 11.5px; color: #5b6570; font-family: 'IBM Plex Mono', Consolas, monospace; }
  .cm-btn-interna { background: #9a5b00; border-color: #7a4800; color: #fff; }
  .cm-btn-interna:hover, .cm-btn-interna:focus { background: #7a4800; color: #fff; }
  .cm-btn-interna[disabled], .cm-btn-interna[disabled]:hover {
    background: #f1ece3; border-color: #e3d9c6; color: #a3927a; opacity: 1; cursor: not-allowed;
  }
  .cm-compositor .btn-primary[disabled] { cursor: not-allowed; }

  .cm-rodape {
    flex: 0 0 auto; background: #f7f9fa; border-top: 1px solid #dfe3e8; padding: 6px 14px;
    display: flex; flex-wrap: wrap; gap: 10px; align-items: center; justify-content: space-between;
  }
  .cm-rodape-info { display: flex; align-items: center; gap: 8px; font-size: 12px; color: #5b6570; }
  .cm-rodape-info .cm-link { margin-left: 4px; font-size: 12px; }
  .cm-rodape-acoes { display: flex; flex-wrap: wrap; align-items: center; justify-content: flex-end; gap: 6px; margin-left: auto; }
  .cm-rodape .cm-btn { height: 30px; padding: 0 12px; font-size: 12.5px; }
  .cm-btn-forte { font-weight: 600; }
  .cm-sep { width: 1px; height: 32px; background: #dfe3e8; margin: 0 4px; }
  .cm-btn-sair { background: #fdf1f1; border: 1px solid #e4d7d7; color: #a13c3c; font-weight: 600; }
  .cm-btn-sair:hover, .cm-btn-sair:focus { background: #fbe7e7; border-color: #d9c2c2; color: #a13c3c; }

  .cm-modal-fundo {
    position: fixed; inset: 0; top: 0; left: 0; right: 0; bottom: 0; background: rgba(28, 32, 36, 0.45);
    display: flex; align-items: center; justify-content: center; padding: 16px; z-index: 2050;
  }
  .cm-modal { width: 100%; max-width: 520px; background: #fff; border-radius: 6px; box-shadow: 0 12px 32px rgba(16, 24, 40, 0.24); overflow: hidden; }
  .cm-modal-topo { padding: 16px 20px 4px; }
  .cm-modal-topo h3 { margin: 0; font-size: 17px; font-weight: 600; }
  .cm-modal-topo p { margin: 6px 0 0; font-size: 12.5px; color: #5b6570; }
  .cm-modal-corpo { padding: 10px 20px 16px; display: flex; flex-direction: column; gap: 12px; }
  .cm-modal-aviso { background: #f7f9fa; border: 1px solid #dfe3e8; border-radius: 4px; padding: 10px 12px; font-size: 12.5px; line-height: 1.5; color: #3d464f; }
  .cm-modal-corpo .cm-campo textarea { height: auto; resize: vertical; }
  .cm-modal-rodape { background: #f7f9fa; border-top: 1px solid #dfe3e8; padding: 10px 14px; display: flex; justify-content: flex-end; gap: 6px; }

  @media (max-height: 760px) {
    .cm-topo { padding: 8px 20px 6px; }
    .cm-titulo p, .cm-compositor-rotulo { display: none; }
    .cm-titulo-icone { width: 32px; height: 32px; font-size: 16px; }
    .cm-kpi { min-height: 38px; padding: 3px 12px 3px 7px; }
    .cm-kpi-icone { width: 22px; height: 22px; font-size: 11px; }
    .cm-filtros { padding: 8px 20px; }
    .cm-compositor { padding: 8px 20px 10px; gap: 6px; }
  }

  @media (max-width: 900px) {
    .cm-topo { flex-wrap: wrap; }
    .cm-kpis { flex-wrap: wrap; margin-left: 0; }
    .cm-page { height: auto; }
    .cm-corpo { flex-direction: column; }
    .cm-lista { flex: 0 0 auto; max-width: none; max-height: 360px; border-right: none; border-bottom: 1px solid #e1e5ea; }
    .cm-conversa { min-height: 520px; }
    .cm-page-embutida.cm-page-unica-embed { height: 100vh; }
    .cm-page-unica-embed .cm-conversa { min-height: 0; }
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/central-mensagens/componentes/CentralMensagens.vue